import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/set-d2c.png'
import _imports_1 from '@/assets/image/set-b2b.png'


const _withScopeId = n => (_pushScopeId("data-v-0226fa30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "order-number-point"
}
const _hoisted_2 = { class: "order-list-table" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_7 = { style: {"margin-left":"4px"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "emailHistoryList"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { style: {"width":"200px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-wenhao1",
  style: {"font-size":"14px","cursor":"pointer"}
}, null, -1))
const _hoisted_18 = { style: {"padding":"0 4px"} }
const _hoisted_19 = { class: "flex-col pay-info" }
const _hoisted_20 = { class: "pay-info-list" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { style: {"font-weight":"600"} }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_27 = {
  key: 0,
  style: {"font-weight":"600"}
}
const _hoisted_28 = {
  key: 1,
  style: {"font-weight":"600"}
}
const _hoisted_29 = {
  key: 2,
  style: {"font-weight":"600"}
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { style: {"font-weight":"600"} }
const _hoisted_32 = { style: {"font-weight":"600"} }
const _hoisted_33 = { style: {"font-weight":"600"} }
const _hoisted_34 = {
  key: 0,
  class: "pay-info-list"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "flex-bwn" }
const _hoisted_37 = {
  key: 0,
  class: "list-dec mr_5"
}
const _hoisted_38 = {
  key: 0,
  class: "paid"
}
const _hoisted_39 = {
  key: 1,
  class: "cur-pay"
}
const _hoisted_40 = {
  key: 2,
  class: "unPaid"
}
const _hoisted_41 = { class: "order-child-table" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 3 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { key: 3 }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("引当処理中")
const _hoisted_63 = /*#__PURE__*/_createTextVNode("システム倉庫変更")
const _hoisted_64 = { class: "flexcenter" }
const _hoisted_65 = { style: {"flex":"1"} }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("予約販売")
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { key: 2 }
const _hoisted_70 = { class: "flex-ter" }
const _hoisted_71 = { style: {"min-height":"84px"} }
const _hoisted_72 = { class: "word-break-en" }
const _hoisted_73 = {
  style: {"width":"200px"},
  class: "word-break-en"
}
const _hoisted_74 = {
  key: 0,
  class: "line--2 word-break-en"
}
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { key: 2 }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = {
  style: {"width":"200px"},
  class: "word-break-en"
}
const _hoisted_79 = { class: "line--2 word-break-en" }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 2 }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 3,
  class: "addition-tip-jp"
}
const _hoisted_84 = { class: "flex-ter" }
const _hoisted_85 = {
  key: 1,
  class: "flex-ter"
}
const _hoisted_86 = {
  key: 2,
  referrerPolicy: "no-referrer",
  src: _imports_0,
  style: {"margin-left":"10px","width":"50px"},
  class: "order-tag"
}
const _hoisted_87 = ["src"]
const _hoisted_88 = {
  key: 4,
  referrerPolicy: "no-referrer",
  src: _imports_1,
  style: {"margin-left":"10px","width":"50px"},
  class: "order-tag"
}
const _hoisted_89 = ["src"]
const _hoisted_90 = /*#__PURE__*/_createTextVNode("引当処理中")
const _hoisted_91 = /*#__PURE__*/_createTextVNode("システム倉庫変更")
const _hoisted_92 = { class: "flexcenter" }
const _hoisted_93 = { style: {"flex":"1"} }
const _hoisted_94 = /*#__PURE__*/_createTextVNode("予約販売")
const _hoisted_95 = { key: 0 }
const _hoisted_96 = ["onClick"]
const _hoisted_97 = { key: 2 }
const _hoisted_98 = { class: "flex-ter" }
const _hoisted_99 = {
  style: {"min-height":"84px"},
  class: "flex-col-center"
}
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { class: "word-break-en" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { key: 1 }
const _hoisted_104 = ["onClick"]
const _hoisted_105 = { key: 0 }
const _hoisted_106 = { key: 1 }
const _hoisted_107 = ["onClick"]
const _hoisted_108 = {
  key: 0,
  class: "quantity-input-number"
}
const _hoisted_109 = {
  key: 0,
  class: "replenish-moq-error"
}
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { key: 1 }
const _hoisted_112 = { key: 1 }
const _hoisted_113 = {
  style: {"width":"200px"},
  class: "word-break-en"
}
const _hoisted_114 = { class: "line--2 word-break-en" }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { key: 2 }
const _hoisted_117 = ["onClick"]
const _hoisted_118 = { style: {"text-align":"center"} }
const _hoisted_119 = { class: "flexcenter" }
const _hoisted_120 = { class: "flex-ter" }
const _hoisted_121 = ["src"]
const _hoisted_122 = ["onClick"]
const _hoisted_123 = { key: 2 }
const _hoisted_124 = {
  key: 0,
  class: "tag-content"
}
const _hoisted_125 = { class: "replenish-tag" }
const _hoisted_126 = {
  key: 1,
  class: "tag-content"
}
const _hoisted_127 = /*#__PURE__*/_createTextVNode("予約販売商品を含む")
const _hoisted_128 = {
  key: 2,
  class: "cancel-tag"
}
const _hoisted_129 = /*#__PURE__*/_createTextVNode("複数倉庫出荷（自動分割）")
const _hoisted_130 = /*#__PURE__*/_createTextVNode("システム倉庫変更")
const _hoisted_131 = /*#__PURE__*/_createTextVNode("Tiktok注文")
const _hoisted_132 = /*#__PURE__*/_createTextVNode("同捆注文")
const _hoisted_133 = /*#__PURE__*/_createTextVNode("ライブ機材")
const _hoisted_134 = { class: "flexcenter mb_5" }
const _hoisted_135 = {
  style: {"width":"200px"},
  class: "word-break-en"
}
const _hoisted_136 = { class: "line--2 word-break-en" }
const _hoisted_137 = { class: "flexcenter" }
const _hoisted_138 = { class: "word-break-en" }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = { key: 2 }
const _hoisted_142 = { key: 1 }
const _hoisted_143 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_144 = { key: 1 }
const _hoisted_145 = {
  class: "flex-bwn-wrap",
  style: {"padding":"4px 0","width":"100%"}
}
const _hoisted_146 = { class: "tooltip-wrap" }
const _hoisted_147 = { class: "header flex -bwn" }
const _hoisted_148 = { class: "title" }
const _hoisted_149 = { class: "content mt_5" }
const _hoisted_150 = ["innerHTML"]
const _hoisted_151 = { key: 1 }
const _hoisted_152 = { key: 0 }
const _hoisted_153 = ["onClick"]
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_155 = ["onClick"]
const _hoisted_156 = { key: 1 }

import SvgIcon from '@/components/icons/SvgIcon.vue'
import UnRechargeModal from '@/components/UnRechargeModal/index.vue'
import UnBalanceConfirm from '@/components/UnBalanceConfirm/index.vue'
import ReplaceGoods from './components/ReplaceGoods/index.vue'
import ReplaceWare from './components/ReplaceWare/index.vue'
import SendEmailDrawer from '../SendEmailList/SendEmailDrawer.vue'
import { t } from '@/plugins/i18n'
import {
  ref,
  toRaw,
  computed,
  reactive,
  watch,
  getCurrentInstance,
  nextTick,
  onMounted,
  onUnmounted
} from 'vue'
import dayjs from 'dayjs'
import {
  QuestionFilled,
  Close,
  Warning,
  CircleClose
} from '@element-plus/icons-vue'
import STable from '@/components/Table/index.vue'
import AppLink from '@/components/common/AppLink.vue'
import GoodsLink from '@/components/common/GoodsLink.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import SSearch from './Search.vue'
import ApplyCancelDialog from '../components/ApplyCancelDialog/index.vue'
import DeliveryPriorityDialog from '../components/DeliveryPriorityDialog/index.vue'
import AfterSalesDialog from '../components/AfterSalesDialog/index.vue'
import RepurchaseDialog from '../components/RepurchaseDialog/index.vue'
import BDialog from './BDialog.vue'
import CombinationDialog from '../components/CombinationDialog.vue'
import ProductStats from '../components/ProductStats.vue'
import DocumentaryRecord from '../components/DocumentaryRecord.vue'
import ProductSku from '../components/ProductSku.vue'
import Guide from '@/components/guide/index.vue'
import FinalPriceDialog from '../components/FinalPriceDialog.vue'
import DeliAdt from '@/components/additional/DeliAdt.vue'
import CommonTip from '@/components/CommonTip/index.vue'
import BatchDeliveryDialog from './BatchDeliveryDialog.vue'
import ExpressSelect from '@/components/ExpressSelect/index.vue'
import { countryCodeNameMap, jpWareInfo, ShopType } from '@/common/const'
import AllPriceDetail from '@/views/shopcart/components/choice/AllPriceDetail.vue'

import Recharge from '@/views/shopcart/components/choice/Recharge.vue'
import CreateOrderSuccess from '@/views/shopcart/components/choice/CreateOrderSuccess.vue'
import Tipstishi from '@/components/IconPark/Tipstishi.vue'
import NoStockModal from '@/views/shopcart/components/NoStockModal.vue'
import {
  getPlatformOrder,
  getPlatformOrderItem,
  getPlatformOrderItemPage,
  postPlatformOrderPay,
  priorityShipping,
  orderRepurchase,
  editDeliveryAdditionsApi,
  editIntShipApi,
  editOrderGoodsAdditionApi,
  getEveryOrderNumberApi,
  isShowShopifyTitleApi,
  partPayApi,
  editCustomerNoApi,
  batchPriorityShipping,
  existPriorityShippingJobApi,
  getPlatformOrderDetail,
  editTransportTypeApi
} from '@/apis/order'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import { getJapanTime, getTrueNumber } from '@/util/common'
import { showCurrentUnit, showPriceAndUnit, allIncludeExchangeRate } from '@/util/useYan'
import { COUNTRY } from '@/global'
import { ElMessage, ElMessageBox } from 'element-plus'
import { normal } from '@/util/useConfirm'
import { canDeliveryPriority } from '../components/DeliveryPriorityDialog/data'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import QuickResponseAdditionTemplateConfirm from '@/components/additional/QuickResponseAdditionTemplateConfirm.vue'
import {
  d2cOrderColumns,
  b2bOrderColumns,
  b2bChildColumns,
  d2cChildColumns,
  tableConfig,
  childConfig,
  d2cOrderTabs,
  b2bOrderTabs,
  childApiConfig,
  orderSourceEnum,
  platformOrderTypeEnum,
  channelEnum,
  combinationStatusDict,
  settlementStatus,
  d2cChoiceChildColumns
} from './data'
import useTable from './useTable'
import useTabData from '@/util/useTabData'
import useFilter from './useFilter'
import { isD2C, useRtfix, useSite2Station, getCustomerShopPlatform, useSite, isKO, isMultiStore, getWarehouseCode, isJA, getWarehouseByCountry, is3RDCustomerShop, isWhiteHiddenRMB } from '@/store'
import axios from 'axios'
import { useStore } from 'vuex'
import { exportFileDownload } from '@/util/useExport'
import { setProdcutLink } from '../data'
import { cancelProgressDict } from '../AbnormalOrder/data'
import CopyButton from '@/components/common/CopyButton.vue'
import { setTimeout } from 'timers'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import { useRoute, useRouter } from 'vue-router'
import { getUser } from '@/apis/login'
import { intShipConfigList } from '@/apis/inShipping'
import { searchUploadProgressApi } from '@/apis/shopcart'
import UploadFail from '@/views/shopcart/components/UploadFail.vue' // 下单失败弹窗
import PartPayDialog from '../components/PartPayDialog.vue'
import BalanceDialog from '../components/BalanceDialog.vue'
import ExpressDrawer from '../components/ExpressDrawer.vue'
import DrawerDocumentaryRecord from '../components/DrawerDocumentaryRecord.vue'
import { isArray, replace } from 'lodash'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import EchartBtn from '@/components/common/EchartBtn.vue'
import {
  montageAddition,
  isConfirmWashAdditionCustomerSku
} from '@/util/calcAdt'
import { getWallet, throughCountryGetExpressApi } from '@/apis/user'
import useEchart, { getVisitorTicketListResult, VisitorTicketListResultItem } from '@/util/useEchart'
import { showModal } from '../ConfirmOrder'
import SelectTransport from '@/components/selectTransport/index.vue'
import { request } from '@/config/request/interceptors'
import { getCustomerWalletList, getUnCheckMoney } from '@/apis/fund'
import { isTkWhiteUserApi } from '@/apis/api'
import confirmDialog from '@/components/common/ConfirmDialog'
import { useEmailSetting } from '@/util/moreRequest'
import { CustomerPlatformOrderRespDTO, PlatformOrderEmailHistoryRespDTO, PlatformOrderEmailPreviewRespDTO } from '@/service/order'
type PlatformOrderEmailPreviewPayload = PlatformOrderEmailPreviewRespDTO & {
  customerShopId?: number
  orderNo?: string
  recipientEmail?: string
}
// 是否点击搜索按钮，点击重置恢复false

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isFilterData = ref(false)
const unBalanceConfirmRef = ref()
const replaceGoodsRef = ref()
const replaceWareRef = ref()
const sendEmailDrawerRef = ref()
const currentUnit = ref('')
const route = useRoute()
const router = useRouter()
const imgHeader =
  'https://static-s.theckb.com/BusinessMarket/Client/fund/split-'
const expressDrawerVisible = ref(false)
const {
  STableRef,
  pageData,
  refreshTable,
  SChildTableRefs,
  handleExpandRow,
  handleExpandAll,
  selectedOrderList,
  expandList,
  handleSelectionChange,
  toggleExpandAllChange,
  changeSelectFn,
  selectPageOption,
  resetChildPageDataList
} = useTable()
const showAdt = ref(false)
const deliveryAdditionalList = ref([])
const { tabData, platformOrderStatus } = useTabData(
  { TabName: 'platformOrderStatus' },
  () => {
    refreshTable(true)
    setOrderNum()
  }
)
const store = useStore()
const isTiktok = computed(() => store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK && isD2C())
const { language, metaData, companyId } = useEchart()
let timer: NodeJS.Timeout | null = null
const echartRecordList = ref<VisitorTicketListResultItem[]>([])
const remarkData = ref()

const isWhiteUser = ref(false)
const replaceWhiteUsers = ref<number[]>([])
// 换仓或者换品白名单
const isReplaceWhiteUser = computed(() => {
  return replaceWhiteUsers.value.includes(store.getters.curShop)
})
const supportCombineAutoAddTk = computed(() => store.state.route.supportCombineAutoAddTk)

onMounted(() => {
  const getEchartRecord = async () => {
    const res: getVisitorTicketListResult = (await axios.get(`https://eapi.echatsoft.com/getVisitorTicketList?metaData=${encodeURIComponent(metaData)}&companyId=${companyId}`)).data
    console.log(res)
    if (res.successful) {
      echartRecordList.value = res.result
      console.log(echartRecordList.value, 'echartRecordList')
    }
  }
  if (isJA()) {
    getEchartRecord()
    timer = setInterval(getEchartRecord, 5000)
  }

  isTkWhiteUserApi().then((res) => {
    isWhiteUser.value = res.data
  })
  request.order.customer.platformOrderQuerySwapWhiteUsers().then(res => {
    replaceWhiteUsers.value = res.data ?? []
  })
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})

/** 批量优先发货弹窗 */
const batchDeliveryModal = ref()

/** 批量优先发货 */
const batchPriorityDelivery = async () => {
  //   如果选择优先发货不为是，则需要提示
  if (orderForm.value.preferDeliverFlag !== '1') {
    ElMessage({
      dangerouslyUseHTMLString: true,
      message: t('请将优先发货筛选项改为是后操作'),
      type: 'warning'
    })
    return
  }
  const data = await existPriorityShippingJobApi()
  //   再次点击时需要判断是否有已经开始的任务
  if (data.data) {
    ElMessage({
      message: t('已经存在提前发货任务'),
      type: 'warning'
    })
    return
  }
  batchDeliveryModal.value.open()
}
/** 批量优先发货-确认 */
const confirmBatchPriorityDelivery = async () => {
  const platformOrderNos = selectedOrderList.value?.map(
    (item) => item.platformOrderNo
  )
  try {
    const res = await batchPriorityShipping({
      platformOrderNos: platformOrderNos
    })
    if (!res?.success) {
      //   ElMessage.error(t('批量优先发货失败'))
      return
    }
    ElMessage({
      message: t('批量优先发货中，请稍等1-3分钟，期间请勿重复操作'),
      type: 'warning'
    })
    // 刷新列表(直接刷新整个页面)
    window.location.reload()
    // search()
  } catch (error) {
    // ElMessage.error(t('批量优先发货失败'))
  }
}

const refreshInfo = () => {
  refreshTable(true)
  setTimeout(() => {
    setOrderNum()
  }, 3000)
}
const exportNum = computed(() => {
  let list: any = []
  for (const k in selectPageOption.value) {
    list = [
      ...list,
      ...selectPageOption.value[k].map((e: any) => e.platformOrderId)
    ]
  }
  return list.length
})
const getImage = (val: string) => {
  return val?.split(',')?.[0]
}
const { orderForm, filterData } = useFilter(platformOrderStatus)
if (route.query.platformOrderNo) {
  const platformOrderNo: any = route.query.platformOrderNo
  orderForm.value.platformOrderNoList = platformOrderNo?.split(',')
}
const rowItem: any = ref({})
const dataList: any = ref([])
// 国际物流列表
const logisticsList: any = ref([])
intShipConfigList({
  systemSource: isD2C() ? 1 : 2,
  stationCode: useSite2Station()
}).then((res: any) => {
  if (res.success) {
    logisticsList.value = res.data
  }
})
const getOrderItem = () => {
  return new Promise<void>((resolve) => {
    getPlatformOrderItem({
      platformOrderId: rowItem.value.platformOrderId,
      source: 2
    })
      .then(async (res: any) => {
        if (res.success) {
          dataList.value = res.data.map(v => ({
            ...v,
            isReplenish: rowItem.value?.tags.includes(7)
          }))
        }
      })
      .finally(() => {
        resolve()
      })
  })
}

const afterSaleVisible = ref(false)
const afterSale = async (row: any) => {
  rowItem.value = toRaw(row)
  row.afterSaleLoading = true
  await getOrderItem()
  row.afterSaleLoading = false
  if (!dataList.value.length) return ElMessage.warning(t('该订单无法进行售后'))
  afterSaleVisible.value = true
}

const deliveryPriorityVisible = ref(false)
const deliveryPriority = async (row: any) => {
  rowItem.value = toRaw(row)
  row.deliveryPriorityLoading = true
  await getOrderItem()
  row.deliveryPriorityLoading = false
  if (!dataList.value.length) { return ElMessage.warning(t('没有可优先发货的商品')) }
  const flag = dataList.value.some((v: any) => canDeliveryPriority(v) || v.isReplenish)
  if (!flag) return ElMessage.warning(t('没有可优先发货的商品'))
  if (dataList.value.length === 1) {
    normal(
      { msg: t('是否确认优先发货') },
      () => {
        priorityShipping(
          dataList.value.map((e: any) => ({
            platformOrderId: e.platformOrderId,
            platformOrderItemId: e.platformOrderItemId
          }))
        ).then((res2: any) => {
          if (res2.success) {
            ElMessage.success(t('优先发货成功'))
          }
        })
      },
      () => null
    )
    return
  }
  if (dataList.value.length > 1) {
    deliveryPriorityVisible.value = true
  }
}

const repurchaseCartVisible = ref(false)
const openRepurchaseCartVisible = async (row: any) => {
  rowItem.value = toRaw(row)
  row.repurchaseCartLoading = true
  await getOrderItem()
  row.repurchaseCartLoading = false
  if (!dataList.value.length) return ElMessage.warning(t('该订单无法复购'))
  if (dataList.value.length === 1) {
    normal(
      { msg: t('确认要追加商品吗？') },
      () => {
        orderRepurchase({
          platformOrderNo: rowItem.value.platformOrderNo,
          repurchaseType: 1,
          shopProductSkus: [dataList.value[0].shopProductSku]
        }).then((res2: any) => {
          if (res2.success) {
            ElMessage.success(t('复购成功'))
          }
        })
      },
      () => null
    )
    return
  }
  if (dataList.value.length > 1) {
    repurchaseCartVisible.value = true
  }
}

const applyCancelVisible = ref(false)
const applyCancel = async (row: any) => {
  rowItem.value = toRaw(row)
  row.applyCancelLoading = true
  await getOrderItem()
  row.applyCancelLoading = false
  // if (!dataList.value.length) return ElMessage.warning(t('没有可申请取消的商品'))
  // const flag = row.platformOrderType === 1
  //   ? dataList.value.some((v: any) => canApplyCancel(v))
  //   : dataList.value.some((v: any) => canStoreApplyCancel(v))
  // if (!flag) return ElMessage.warning(t('没有可申请取消的商品'))
  applyCancelVisible.value = true
}

const inVisible = ref(false)
const international = (row: any) => {
  rowItem.value = toRaw(row)
  inVisible.value = true
}

const combinationVisible = ref(false)
const openCombinationVisible = (row: any) => {
  rowItem.value = toRaw(row)
  combinationVisible.value = true
}

const exportLoading = ref(false)
const exportOrder = (type: number) => {
  // if (!selectedOrderList.value.length) return ElMessage.warning(t('请选择需要导出的订单'))
  let list: any = []
  for (const k in selectPageOption.value) {
    list = [
      ...list,
      ...selectPageOption.value[k].map((e: any) => e.platformOrderId)
    ]
  }
  const platformOrderIds = list.join(',')

  if (!list.length && STableRef.value.tableCount > 3000) {
    ElMessage.warning('選択したデータが上限（3,000件）を超えています。条件を絞って再度お試しください。')
    return
  }
  // return
  exportLoading.value = true
  axios({
    method: 'post',
    url:
      process.env.VUE_APP_URL +
      (type === 1 ? '/order/customer/platformOrderItem/exportOrderCommodityInfo' : '/order/customer/platformOrderItem/exportOrderCommodityInfo3rd'),
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-AuthShopId': store.getters.curShop,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '20260225-export',
      'X-Platform': 'PC'
    },
    data: list.length ? {
      platformOrderIds: list
    } : (isBatchSearch.value ? batchSearchParams.value : filterData.value)
  })
    .then((res: any) => {
      exportFileDownload(res, { name: t('我的订单') })
    })
    .finally(() => {
      exportLoading.value = false
      refreshTable()
    })
}
const templateLevel = ref(store.getters.membership.templateLevel)
const isSub = store.getters.isSub
const token = store.getters.token
const popverIndex = ref(0)
const { proxy } = getCurrentInstance() as any
const goods = ref([])
const visible = ref(false)
const payRow = ref({})
const toPay = async (row: any, type?: number) => {
  await getBalance()
  payRow.value = row
  // 批量标志type
  getUser(token).then(async (res: any) => {
    if (res.success) {
      const apis = []
      templateLevel.value = res.data.membership.templateLevel
      // 无需校验会员
      const pass = true
      if (!pass && res.data.membership.templateLevel === 0) {
        if (type) {
          ElMessage.warning(t('尊敬的用户，您需办理会员后，方可下单'))
          return
        }
        STableRef.value.tableData.forEach((item: any) => {
          if (proxy.$refs[`memberPopver${item.platformOrderId}`]) {
            proxy.$refs[`memberPopver${item.platformOrderId}`].open = false
          }
        })
        popverIndex.value = row.platformOrderId
        // 关闭tips
        proxy.$refs[`memberPopver${row.platformOrderId}`].open = true
      } else {
        // 智能补货计划的待支付订单直接跳转待支付详情页
        if (row.tags?.includes(7)) {
          router.push(
            useRtfix('ConfirmOrder', {
              query: {
                id: row.platformOrderId,
                sc: row?.deliveryCountry,
                isReplenish: 1
              }
            })
          )
          return
        }
        // 批量下单仅支持表格下单
        if (type) {
          router.push(
            useRtfix('ConfirmOrder', {
              query: {
                id: selectedOrderList.value
                  .map((item: any) => item.platformOrderId)
                  .join(','),
                sc: selectedOrderList.value[0]?.deliveryCountry
              }
            })
          )
          return
        }
        // 表格下单去支付跳转确认支付页confirmorder
        if (row.orderSource === 6) {
          router.push(
            useRtfix('ConfirmOrder', { query: { id: row.platformOrderId, sc: row.deliveryCountry } })
          )
          return
        }
        // 订单信息查询
        const res1 = await getPlatformOrderDetail({
          platformOrderId: row.platformOrderId
        })
        const OrderProductDetailList: any = []
        if (res1.success) {
          res1.data?.platformOrderItemList?.forEach((j: any) => {
            OrderProductDetailList.push({
              product_num: j.orderQuantity,
              product_title_ja: j.productTitleJp,
              product_code: j.productCode
            })
          })
        }
        if (row.orderSource === 10) {
          const noAdtItem = res1.data.platformOrderItemList.find(v => v.platformOrderItemAdditionDTOList === '-' && v.noAdditionalFlag !== 1)
          if (noAdtItem) {
            console.log(STableRef.value.isFilp(row))
            ElMessage.warning(t('附加项验证'))
            if (!STableRef.value?.isFilp(row)) {
              STableRef.value.expandRowChange(row)
            }
            return
          }
        }
        try {
          row.payLoading = true
          const res = await request.order.customer.platformOrderPay({
            platformOrderId: row.platformOrderId
          })
          if (res.success) {
            // 校验线下商品库存
            const { stockSkus, downSkus, validSkus, firstOrderFlag, meetFreeShipFlag } = res.data!
            if (stockSkus?.length) {
              getPlatformOrderItem({
                platformOrderId: row.platformOrderId,
                source: 2
              }).then((res: any) => {
                const list: any = []
                res.data.forEach((item: any) => {
                  if (
                    stockSkus.includes(item.productSku) &&
                    item.channel === 5
                  ) {
                    list.push({
                      ...item,
                      price: item.actualProductSellPrice
                    })
                  }
                })
                if (list.length === 0) {
                  taTrack({
                    event: TaEvent.ORDER_PAY,
                    value: {
                      currency: 'CNY',
                      order_no: row.platformOrderNo,
                      pay_amount: row.totalFreezeAmount,
                      pay_result: 'fail',
                      fail_reason: '',
                      order_product_detail: OrderProductDetailList
                    }
                  })
                  ElMessage.warning(t('支付失败'))
                  return
                }
                goods.value = list
                visible.value = true
              })
              return
            } else if (downSkus?.length || validSkus?.length) {
              taTrack({
                event: TaEvent.ORDER_PAY,
                value: {
                  currency: 'CNY',
                  order_no: row.platformOrderNo,
                  pay_amount: row.totalFreezeAmount,
                  pay_result: 'fail',
                  fail_reason: '',
                  order_product_detail: OrderProductDetailList
                }
              })
              ElMessage.warning(t('支付失败'))
              return
            }

            taTrack({
              event: TaEvent.ORDER_PAY,
              value: {
                currency: 'CNY',
                order_no: row.platformOrderNo,
                pay_amount: row.totalFreezeAmount,
                pay_result: 'success',
                fail_reason: '',
                order_product_detail: OrderProductDetailList
              }
            })

            if (isJA()) {
              localStorage.setItem('ckb_last_order_id', row.platformOrderId)
              if (firstOrderFlag) {
                window.location.href = `/order_complete_first?hasCoupon=${meetFreeShipFlag ? 1 : 0}`
              } else {
                window.location.href = '/order_complete'
              }
            } else {
              ElMessage.success(t('支付成功'))
              refreshTable()
            }
          } else {
            if (res.code === '22010002') {
              // 余额不足
              if (row.tags.includes(4)) {
                getPlatformOrderItem({
                  source: 1,
                  platformOrderId: row.platformOrderId
                }).then((res: any) => {
                  payGoodsList.value = res.data

                  rechargeRef.value.open()
                })
              } else {
                getCustomerWalletList({
                  stationCode: useSite2Station(),
                  currencyCode: row?.deliveryCountry === COUNTRY.KR ? 'KRW' : 'CNY'
                }).then(async (res: any) => {
                  const { data } = res
                  const recharge = data.find?.((e: any) => e.accountType === 1)?.availableAmount ?? 0
                  const unCheckCnyAmt = await getUnCheckMoney({ currencyCode: row?.deliveryCountry === COUNTRY.KR ? 'KRW' : 'CNY' }).then(res => {
                    return res.data.unCheckCnyAmt
                  })
                  if (recharge > 0 || unCheckCnyAmt > 0) {
                    bus.emit('openUnRechargeModal', {
                      currency: row?.deliveryCountry === COUNTRY.KR ? 'KRW' : 'CNY',
                      unCheckCnyAmt
                    })
                  } else {
                    unBalanceConfirmRef.value?.open()
                    // showModal(router)
                  }
                })
              }
            }
            if (res.code === '22010091') {
              ElMessage.warning(t('待支付的订单才能重新支付，请确认后重新选择'))
            }
            if (res.code === '260000001' && row.tags.includes(4)) {
              ElMessageBox.confirm(t('当前商品价格发生变化，请确认后决定是否下单'), t('提示'), {
                confirmButtonText: t('关闭2'),
                showCancelButton: false,
                showClose: false,
                type: 'warning'
              })
            }
            if (res.code === '240000055' && row.tags.includes(4)) {
              // 一口价订单价格变化时
              ElMessageBox.confirm(t('一口价订单金额发生变化，请重新确认'), t('提示'), {
                confirmButtonText: t('确定'),
                cancelButtonText: t('取消'),
                type: 'warning'
              })
              changeTransportType(row.platformOrderId, row.transportType)
            }
            taTrack({
              event: TaEvent.ORDER_PAY,
              value: {
                currency: 'CNY',
                order_no: row.platformOrderNo,
                pay_amount: row.totalFreezeAmount,
                pay_result: 'fail',
                fail_reason: res.msg,
                order_product_detail: OrderProductDetailList
              }
            })
          }
        } catch (error) {

        } finally {
          row.payLoading = false
        }
      }
    }
  })
}

const toPay2 = (row: any) => {
  STableRef.value.tableData.forEach((item: any) => {
    if (proxy.$refs[`memberPopver${item.platformOrderId}`]) {
      proxy.$refs[`memberPopver${item.platformOrderId}`].open = false
    }
  })
  popverIndex.value = row.platformOrderId
  proxy.$refs[`memberPopver${row.platformOrderId}`].open = true // 关闭tips
}

const closePopver = () => {
  proxy.$refs[`memberPopver${popverIndex.value}`].open = false // 关闭tips
}

const orderClassName = ({ row, rowIndex }: any) => {
  if (expandList.value && expandList.value.includes(row.platformOrderId)) {
    return 'expand-status'
  } else {
    return ''
  }
}
const tableData = computed(() => {
  return STableRef.value?.tableData || []
})
const tableCount = computed(() => {
  return STableRef.value?.tableCount || 0
})
const finalStatus = ref(false)
const finalData = ref()
const checkFinalPrice = (row: any) => {
  finalData.value = row.settlePriceList
  currentUnit.value = showCurrentUnit(row.goodsCountry === COUNTRY.KR)
  finalStatus.value = true
}

const jump = (url: any) => {
  const routerUrl: any = router.resolve(url)
  window.open(routerUrl.href, '_blank')
}

const jumpCancel = (row: any, scope: any) => {
  const routerUrl: any = router.resolve(
    useRtfix('AbnormalOrder', {
      query: {
        abnormal: 'ApplyCancel',
        platformOrderNo2: scope.platformOrderNo,
        productSku: row.productSku,
        processManner: '1'
      }
    })
  )
  window.open(routerUrl.href, '_blank')
}
const dataListenerFn = (data: any) => {
  expandList.value = []
  resetChildPageDataList(data)
  changeSelectFn(data)
  setTimeout(() => {
    if (remarkData.value?.platformOrderId) {
      // handleExpandRow(remarkData.value, true)
      STableRef.value.expandRowChange(remarkData.value)
    }
  }, 500)
}
const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  if (params.productSkuList) {
    // 商品搜索
    router.push(
      useRtfix('OrderSearch', {
        query: { productSkuList: params.productSkuList.join(',') }
      })
    )
  }
  if (params.customerProductMskuList) {
    // 商品搜索
    router.push(
      useRtfix('OrderSearch', {
        query: {
          customerProductMskuList: params.customerProductMskuList.join(',')
        }
      })
    )
  }
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    customerShopId: filterData.value.customerShopId
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
  isFilterData.value = true
}

// 批量付款
const batchPay = () => {
  if (selectedOrderList.value.length === 0) {
    ElMessage.warning(t('请勾选订单'))
    return
  }
  let country = ''
  let isWarning = false
  selectedOrderList.value.forEach((i: { deliveryCountry: string }) => {
    if (!country) {
      country = i.deliveryCountry
      return
    }
    if (country !== i.deliveryCountry) {
      isWarning = true
    }
  })
  if (isWarning) {
    ElMessage.warning(t('请选择相同发货国家的订单'))
    return
  }
  toPay({}, 1)
}

const parentTableConfig = {
  ...tableConfig,
  // 待付款tab 只能勾选表格下单的订单 一价全包不支持批量支付
  selectable: (row: any) =>
    tabData.value !== '2' || (tabData.value === '2' && (row.orderSource === 6 || row.orderSource === 10) && !row.tags?.includes(4))

}
let waitOrderItem: any = {}
const openDt = (row: any) => {
  waitOrderItem = row
  // row.platformOrderDeliveryAdditionalList[0].additionConfigId = 488
  // row.platformOrderDeliveryAdditionalList[0].ingredientsSku = "OPS22062304000009"
  deliveryAdditionalList.value = row.platformOrderDeliveryAdditionalList
  showAdt.value = true
}
// 表格下单编辑附加项
const editSendAddition = (e: any) => {
  editDeliveryAdditionsApi({
    platformOrderId: waitOrderItem.platformOrderId,
    deliveryAdditionalList: e.map((i: any) => {
      return {
        additionConfigId: i.additionConfigId,
        ingredientsSku: i.ingredientsSku === '-' ? '' : i.ingredientsSku,
        additionExtraName: i.additionNameJp
      }
    })
  }).then((res: any) => {
    if (res.success) {
      refreshTable(true)
    }
  })
}
// 表格下单编辑国际物流
const changeLogistics = async (row: any, expressItem: any) => {
  const resData = await editIntShipApi({
    platformOrderId: row.platformOrderId,
    intShipConfigId: expressItem.intShipConfigId,
    intForwarderConfigId: expressItem?.forwarders?.[0]?.intForwarderConfigId
  })
  if (resData.success) {
    ElMessage.success(t('修改成功'))
    refreshTable(true)
    return true
  } else {
    return false
  }
}
const additionVisible = ref(false)
const goodsAdditionList: any = ref(null)
const additionCountryCode = ref('CN')
const orderItem: any = ref({})
const goodsRowItem: any = ref({}) //
/** 小单快反默认附加项模板确认弹窗实例。 */
const quickResponseAdditionTemplateConfirmRef = ref()
const choiceCost = ref(false)
const hiddenRMB = ref(false)
const openAddition = (row: any, order: any) => {
  choiceCost.value = order.tags?.includes(4)
  goodsRowItem.value = {
    ...row,
    platformOrderItemAdditionDTOList: (row.platformOrderItemAdditionDTOList === '-' ? [] : row.platformOrderItemAdditionDTOList ?? [])?.map((item: any) => {
      return {
        ...item,
        washedlabelSpecification:
          item.washedlabelSpecification === '-'
            ? null
            : item.washedlabelSpecification,
        spotCheckRatio: item.spotCheckRatio && item.spotCheckRatio !== '-' ? item.spotCheckRatio : ''
      }
    })
  }
  orderItem.value = order
  hiddenRMB.value = row?.allIncludePriceResultDetail?.allIncludeType === 2
  goodsAdditionList.value = row.platformOrderItemAdditionDTOList === '-' ? [] : row.platformOrderItemAdditionDTOList.map((item: any) => {
    return {
      ...item,
      washedlabelSpecification: item.washedlabelSpecification === '-' ? null : item.washedlabelSpecification
    }
  })
  additionCountryCode.value = row.goodsCountry
  additionVisible.value = true
}
const noReset = ref(false)
const handleAdt = async (adt: any) => {
  editOrderGoodsAdditionApi({
    platformOrderId: orderItem.value?.platformOrderId,
    platformOrderItemIdList: [goodsRowItem.value.platformOrderItemId],
    cartAdditionList:
      adt === 1
        ? []
        : adt.map((i: any) => {
          return {
            shopProductSku: goodsRowItem.value.shopProductSku,
            additionConfigId: i.additionConfigId,
            additionId: i.additionId,
            ingredientsSku: i.ingredientsSku === '-' ? '' : i.ingredientsSku,
            additionExtraName: i.additionExtraName,
            washedlabelAdditionId:
              i.washedlabelAdditionId === '-' ? '' : i.washedlabelAdditionId,
            washedlabelSpecification:
              i.washedlabelSpecification === '-'
                ? ''
                : i.washedlabelSpecification,
            spotCheckRatio: i.spotCheckRatio && i.spotCheckRatio !== '-' ? i.spotCheckRatio : '',
            spotCheckFlag: i.spotCheckFlag
          }
        }),
    noAdditionalFlag: adt === 1 ? 1 : 0
  }).then((res: any) => {
    if (res.success) {
      if (goodsRowItem.value.oemBusinessType === 2 && isJA()) {
        quickResponseAdditionTemplateConfirmRef.value?.checkAndOpen(adt)
      }

      ElMessage.success(t('修改成功'))
      SChildTableRefs.value[orderItem.value?.platformOrderId].getData()
      getPlatformOrder({
        platformOrderNoList: [orderItem.value.platformOrderNo],
        customerShopId: store.getters.curShop
      }).then((result: any) => {
        noReset.value = true
        const item = result.data.records?.[0]
        const index = STableRef.value.tableData.findIndex(v => v.platformOrderNo === orderItem.value.platformOrderNo)
        if (index === -1) return
        STableRef.value.tableData[index].productAdditionFreezeAmount = item.productAdditionFreezeAmount
        STableRef.value.tableData[index].totalFreezeAmount = item.totalFreezeAmount
      })
      // refreshTable(true)
    }
  })
}
const orderNumObj: any = ref({
  allCount: 0,
  waitPayCount: 0,
  dealingCount: 0,
  canDeliverCount: 0,
  partDeliverCount: 0,
  completeCount: 0
})
const tabList = computed(() => {
  const list = JSON.parse(
    JSON.stringify(isD2C() ? d2cOrderTabs : b2bOrderTabs)
  )
  // list.forEach((item:any) => {
  //   if (item.name === 'all') {
  //     item.title += orderNumObj.value.allCount > 0 ? `(${orderNumObj.value.allCount})` : ''
  //   }
  //   if (item.name === '2') {
  //     item.title += orderNumObj.value.waitPayCount > 0 ? `(${orderNumObj.value.waitPayCount})` : ''
  //   }
  //   if (item.name === '4') {
  //     item.title += orderNumObj.value.dealingCount > 0 ? `(${orderNumObj.value.dealingCount})` : ''
  //   }
  //   if (item.name === '8') {
  //     item.title += orderNumObj.value.canDeliverCount > 0 ? `(${orderNumObj.value.canDeliverCount})` : ''
  //   }
  //   if (item.name === '16') {
  //     item.title += orderNumObj.value.partDeliverCount > 0 ? `(${orderNumObj.value.partDeliverCount})` : ''
  //   }
  //   if (item.name === '32') {
  //     item.title += orderNumObj.value.completeCount > 0 ? `(${orderNumObj.value.completeCount})` : ''
  //   }
  // })
  return list
})
const setOrderNum = () => {
  getEveryOrderNumberApi({}).then((res: any) => {
    if (res.success) {
      orderNumObj.value = res.data
    }
  })
}
setOrderNum()
const uploadFailVisible = ref(false)
const failInfo = ref({})
searchUploadProgressApi({
  taskType: 1
}).then((res: any) => {
  const { knowFlag, taskStatus } = res.data
  if (taskStatus === 3 && knowFlag === 1) {
    // 导入失败 && 未知晓
    uploadFailVisible.value = true
    failInfo.value = res.data
  }
})

const drawerDocumentaryRecordRef = ref()

const openExpress = (info: any, row: any, status: number) => {
  drawerDocumentaryRecordRef.value.open({
    info: info,
    row,
    status
  })
}
const isStoreApi = computed(
  () => store.getters.shopInfo?.customerShopPlatform === 3
)
const isShopify = ref(false)
isShowShopifyTitleApi().then((res: any) => {
  isShopify.value = res.data?.isSubscription || isStoreApi.value
})
const jumpAbnormalOrder = (
  row: any,
  type: string,
  status: any,
  scope?: any
) => {
  const query = {
    customerOperateStatus: status,
    platformOrderNo: row.platformOrderNo || scope.platformOrderNo,
    productSku: row.productSku
  }
  router.push(useRtfix('AbnormalOrder', { query }))
}
/** 分期支付信息确认 */
const partPayVisible = ref(false)
const partPayLoading = ref(false)
/** 余额不足弹窗 */
const balanceVisible = ref(false)
/** 打开分期付款支付信息弹窗 */
const openConfirmPartPayInfo = (row: any) => {
  partPayVisible.value = true
  rowItem.value = row
}
// 分期付款
const handlePartPay = async () => {
  /**
          enum FREEZE_STATUS { // freezeStatus
          '未冻结' = 1,
          '冻结中' = 2,
          '冻结成功' = 3,
          '冻结失败' = 4
          }

          enum PURCHASE_APPLY { // purchaseApplyFlag
            '未发起' = false,
            '已发起' = true,
          }
         */
  try {
    /** 找到需支付的账期序号：stageNo */
    const obj = rowItem.value.stageInfos.find((item: any) => {
      return [1, 4].includes(item.freezeStatus) && item.purchaseApplyFlag
    })
    partPayLoading.value = true
    const res = await partPayApi({
      customerShopId: store.getters.curShop,
      platformOrderNo: rowItem.value.platformOrderNo,
      stageNo: obj.stageNo
    })
    const row = rowItem.value

    // 订单信息查询
    const res1 = await getPlatformOrderDetail({
      platformOrderId: row.platformOrderId
    })
    const OrderProductDetailList: any = []
    if (res1.success) {
      res1.data?.platformOrderItemList?.forEach((j: any) => {
        OrderProductDetailList.push({
          product_num: j.orderQuantity,
          product_title_ja: j.productTitleJp,
          product_code: j.productCode
        })
      })
    }
    if (res.success) {
      // TODO:埋点
      taTrack({
        event: TaEvent.ORDER_PAY,
        value: {
          currency: 'CNY',
          order_no: row.platformOrderNo,
          pay_amount: row.totalFreezeAmount,
          pay_result: 'success',
          fail_reason: '',
          order_product_detail: OrderProductDetailList
        }
      })
      ElMessage.success(t('支付成功'))
      partPayVisible.value = false
      partPayLoading.value = false
      refreshTable()
    } else {
      if (res.msg === '钱包余额不足') {
        taTrack({
          event: TaEvent.ORDER_PAY,
          value: {
            currency: 'CNY',
            order_no: row.platformOrderNo,
            pay_amount: row.totalFreezeAmount,
            pay_result: 'fail',
            fail_reason: '钱包余额不足',
            order_product_detail: OrderProductDetailList
          }
        })
        partPayLoading.value = false
        partPayVisible.value = false
        balanceVisible.value = true
      }
    }
  } catch (err) {
    partPayLoading.value = false
  }
}

// 编辑客户订单编号
const saveCustomerNo = (row: any) => {
  console.log(row)
  if (!row.customerOrderNo || row.customerOrderNo === '-') {
    return
  }
  row.loading = true
  editCustomerNoApi({
    customerOrderNo: row.customerOrderNo,
    platformOrderNo: row.platformOrderNo
  })
    .then(() => {
      row.edit = false
      nextTick(() => {
        STableRef.value && STableRef.value.getData()
      })
    })
    .finally(() => {
      row.loading = true
    })
}

const [emailSetting] = useEmailSetting()

// table 订单字段
const columns = computed(() => {
  const list = isD2C() ? (d2cOrderColumns.filter((i: any) => isShopify.value || i.prop !== 'orderName')) : b2bOrderColumns
  const newList = list.map((i: any) => {
    if (i.prop === 'orderName' && isD2C()) {
      i.label = t('订单') + `(${getCustomerShopPlatform()})`
    }
    return i
  }).concat((isKO() && isD2C()) ? [{
    label: t('国际物流单号'),
    prop: 'trackingNumber',
    // slotName: 'payInfoSlot',
    align: 'center',
    width: 120
  }] : [])

  if (isTiktok.value) {
    const index = newList.findIndex(v => v.prop === 'createTime')
    newList.splice(index, 0, {
      label: t('截止发货时间'),
      prop: 'rtsSlaTime',
      width: 110,
      align: 'center',
      slotName: 'rtsSlaTime'
    })
  }

  if (isD2C() && emailSetting.value?.whitelistEnabled) {
    newList.push({
      label: t('メール'),
      prop: 'emailHistoryList',
      width: 160,
      align: 'center',
      slotName: 'emailHistoryList'
    })
  }

  // 过滤韩国仓字段
  const filterKoreaColumns = newList.filter((v: { isMultiStore: boolean }) => isMultiStore() || !v.isMultiStore)
  const filterNoTiktokColumns = filterKoreaColumns.filter(i => isD2C() ? true : i.prop !== 'wareCode')
  return filterNoTiktokColumns
})
// table 订单下商品列表字段
const childColumns = computed(() => {
  const list = isD2C() ? d2cChildColumns : b2bChildColumns
  return list
})

// 商品行金额转换，并区分过滤 商品所在地字段
const getChildColumns = (col: any, record: any) => {
  const columns = [...col]
  if (record.tags.includes(4)) {
    // 一价全包table
    return d2cChoiceChildColumns
  }
  if (record.tags.includes(12)) {
    columns.splice(columns.findIndex((v: any) => v.prop === 'productSku') + 1, 0, {
      label: t('订单') + `(${getCustomerShopPlatform()})`,
      width: 180,
      align: 'center',
      prop: 'customerOrderNo',
      slotName: 'customerOrderNo'
    })
  }
  const isReplenish = record.tags?.includes(7) && record.platformOrderStatus === 2
  return columns.filter((v: { isMultiStore: boolean }) => isMultiStore() || !v.isMultiStore).map((item: any) => {
    // if (['actualProductSellPrice', 'actualTotalProductSellPrice', 'averagePrice', 'final'].includes(item.prop)) {
    //   return {
    //     ...item,
    //     label: item.label + (isMultiStoreType ? '(KRW)' : '(CNY)')
    //   }
    // }
    return item
  }).filter(v => {
    if (v.show) {
      if (isReplenish && v.show?.includes(7)) {
        return true
      }
      return false
    }
    if (v.hidden) {
      if (isReplenish && v.hidden?.includes(7)) {
        return false
      }
      return true
    }
    return true
  })
}
const getExpressData = async (item: any) => {
  const resData = await getPlatformOrderItem({
    platformOrderId: item.platformOrderId,
    source: 1
  })
  let skuList: any = []
  resData.data.forEach((v: any) => {
    if (v.productType === 3) {
      skuList = [
        ...skuList,
        ...v.combinationOrderItemList.map((temp: any) => {
          return {
            num: temp.orderQuantity,
            productSku: temp.productSku,
            productType: temp.productType
          }
        })
      ]
      return
    }
    skuList.push({
      num: v.orderQuantity,
      productSku: v.productSku,
      productType: v.productType
    })
  })
  return {
    skuList,
    countryCode:
      item.receivingCountryCode === '-' ? 'JP' : item.receivingCountryCode,
    systemSource: isD2C() ? 1 : 2
  }
}
const batchExpressList = ref({
  CN: [],
  KR: [],
  JP: []
})
const getExpress = async () => {
  // 获取物流列表
  const res = await throughCountryGetExpressApi({
    countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.CN)
  })
  if (res.success) {
    const newData = res.data.map((item: { forwarders: any[]; countryCode: any }) => {
      const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
      item.countryCode = [...new Set(countryCodeArray)].join(',')
      return item
    })
    batchExpressList.value.CN = newData
  }
  const resData = await throughCountryGetExpressApi({
    countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.KR)
  })
  if (resData.success) {
    const newData = resData.data.map((item: { forwarders: any[]; countryCode: any }) => {
      const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
      item.countryCode = [...new Set(countryCodeArray)].join(',')
      return item
    })
    batchExpressList.value.KR = newData
  }
  const resDataJP = await throughCountryGetExpressApi({
    countryCode: selectedOrderList.value[0]?.receiver?.countryCode,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: getWarehouseByCountry(COUNTRY.JP)
  })
  if (resDataJP.success) {
    const newData = resDataJP.data.map((item: { forwarders: any[]; countryCode: any }) => {
      const countryCodeArray = item.forwarders.map((forwarder: { countryCode: any }) => forwarder.countryCode)
      item.countryCode = [...new Set(countryCodeArray)].join(',')
      return item
    })
    batchExpressList.value.JP = newData
  }
  console.log(batchExpressList.value)
}
getExpress()

const getAveragePrice = (row: any) => {
  if (row.settlePriceList?.length > 1 && (row.productType !== 3)) {
    let price = getTrueNumber(row.settlePriceList.reduce((total: number, v: any): number => {
      return total + v.price
    }, 0) / row.settlePriceList.reduce((total: number, v: any): number => {
      return total + v.num
    }, 0))
    if (row?.goodsCountry === COUNTRY.KR) {
      price = Math.ceil(price)
    }
    return showPriceAndUnit(price, showCurrentUnit(COUNTRY.KR === row.goodsCountry))
  }
  const price = row.settlePriceList?.[0]?.price
  const num = row.settlePriceList?.[0]?.num
  if (price && row.productType !== 3) {
    let p = getTrueNumber(price / num)
    if (row?.goodsCountry === COUNTRY.KR) {
      p = Math.ceil(p)
    }
    return showPriceAndUnit(p, showCurrentUnit(COUNTRY.KR === row.goodsCountry))
  }
  return '-'
}
const noAdd = (row: any, order: any) => {
  goodsRowItem.value = row
  orderItem.value = order
  additionCountryCode.value = row.goodsCountry
  handleAdt(1)
}

const getPayTitle = (row: any) => {
  if (row.tags.includes(4) && row.exchangeRate !== allIncludeExchangeRate.value) {
    return t('一口价订单汇率已更新，请确认支付')
  }
  return t('是否去支付')
}

const rechargeRef = ref()
const figurePayRef = ref()
const shopWallet = ref(0)
const getBalance = async () => {
  const wallet = await getWallet({
    customerShopId: store.getters.curShop,
    currencyCode: 'CNY'
  }).then((res) => res.data.availableAmount)
  shopWallet.value = wallet
  return wallet
}
getBalance()
const paySuccess = async () => {
  await getBalance()
  toPay(payRow.value)
}
const payGoodsList: any = ref([])
const choiceTotalAmount = computed(() => {
  console.log('tableData.value', tableData.value)
  const list = payGoodsList.value
  return {
    // 商品代金
    productResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeProductPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeProductPrice ?? 0)
      }, 0)
    },
    // 手续费
    defaultAdditionResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.defaultAdditionPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.defaultAdditionPrice ?? 0)
      }, 0)
    },
    // 商品附加项
    productAdditionResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeProductPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeProductPrice ?? 0)
      }, 0)
    },
    // 国际运费
    internalShipResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeShipPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeShipPrice ?? 0)
      }, 0)
    },
    // 关税
    allIncludeTaxResult: {
      totalAmt: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeTaxPriceExchange ?? 0)
      }, 0),
      totalAmtCn: list.reduce((total: number, v: any): number => {
        return total + (v.allIncludePriceResultDetail?.allIncludeTaxPrice ?? 0)
      }, 0)
    },
    totalAmt: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPriceExchange ?? 0)
    }, 0),
    totalAmtCn: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPrice ?? 0)
    }, 0),
    totalPriceCNY: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPrice ?? 0)
    }, 0),
    totalPriceJPY: list.reduce((total: number, v: any): number => {
      return total + (v.allIncludePriceResultDetail?.allIncludeProductTotalPriceExchange ?? 0)
    }, 0),
    totalQuantity: list.reduce((total: number, v: any): number => {
      return total + (v.orderQuantity ?? 0)
    }, 0)
  }
})

const changeTransportType = (platformOrderId: string, type: number) => {
  editTransportTypeApi({
    platformOrderId: platformOrderId,
    transportType: type
  }).then(({ success }: any) => {
    if (success) {
      nextTick(() => {
        STableRef.value && STableRef.value.getData()
      })
    }
  })
}

/** 修正补货数量输入的兜底值。 */
const normalizeRecommendReplenishQuantity = (row: any, min: number) => {
  if ((!row?.orderQuantity && row?.orderQuantity !== 0) || isNaN(row?.orderQuantity) || (Number(row.orderQuantity) === 0 && min === 1)) {
    row.orderQuantity = 1
  }
}

/** 处理补货数量输入框失焦，刷新 MOQ 提示后提交调整。 */
const handleRecommendReplenishQuantityBlur = async (row: any, order: any, min: number) => {
  normalizeRecommendReplenishQuantity(row, min)
  validateReplenishMoq(row, order)
  await changeRecommendReplenishQuantity(row, order)
}

/** 提交补货数量修改。 */
const changeRecommendReplenishQuantity = async (row: any, order: any) => {
  if (Number(row.orderQuantity) === 0) {
    confirmDialog({
      title: t('提示'),
      text: 'このSKUを補充リストから削除してもよろしいですか？<br/>削除後、該当SKUを含む未出荷の直送注文がある場合は、手動でカートから補充依頼を作成する必要があります。',
      htmlNode: true,
      okText: t('确认'),
      cancelText: t('取消'),
      onCancel: () => {
        submitFn(row, order)
      }
    }).then(() => {
      submitFn(row, order, true)
    })
    return
  }
  submitFn(row, order, true)
}
const submitFn = async (row: any, order: any, isSubmit?: boolean) => {
  if (isSubmit) {
    const res = await request.order.customer.platformOrderEditRecommendReplenishQuantity({
      platformOrderItemId: row.platformOrderItemId,
      recommendReplenishQuantity: row.orderQuantity
    })
    if (res.success) {
      ElMessage.success(t('修改成功'))
    }
  }
  nextTick(() => {
    SChildTableRefs.value?.[row.platformOrderId]?.getData()
    getPlatformOrder({
      platformOrderNoList: [order.platformOrderNo],
      customerShopId: store.getters.curShop
    }).then((result: any) => {
      noReset.value = true
      const item = result.data.records?.[0]
      const index = STableRef.value.tableData.findIndex(v => v.platformOrderNo === order.platformOrderNo)
      if (index === -1) return
      STableRef.value.tableData[index].productAdditionFreezeAmount = item.productAdditionFreezeAmount
      STableRef.value.tableData[index].totalFreezeAmount = item.totalFreezeAmount
    })
  })
}

/** 获取当前订单展开商品子表数据。 */
const getChildTableRows = (order: any, row?: any) => {
  /** 当前订单展开商品子表实例。 */
  const childTableRef = SChildTableRefs.value?.[order?.platformOrderId]
  /** 当前订单展开商品子表暴露出来的行数据，兼容 ref 和已解包数组。 */
  const exposedTableData = childTableRef?.tableData
  /** 当前订单展开商品子表行数据。 */
  const childRows = Array.isArray(exposedTableData) ? exposedTableData : (Array.isArray(exposedTableData?.value) ? exposedTableData.value : [])
  if (!row) return childRows
  /** 当前编辑行在子表数据中的索引。 */
  const currentRowIndex = childRows.findIndex((item: any) => item?.platformOrderItemId === row?.platformOrderItemId)
  if (currentRowIndex === -1) return [...childRows, row]
  return childRows.map((item: any, index: number) => index === currentRowIndex ? row : item)
}

/** 获取补货 MOQ 校验使用的输入数量。 */
const getReplenishInputQuantity = (row: any) => {
  /** 当前输入框内的补货数量。 */
  const inputQuantity = Number(row?.orderQuantity)
  return Number.isNaN(inputQuantity) ? 0 : inputQuantity
}

/** 清空商品子表 MOQ 错误提示。 */
const clearReplenishMoqErrors = (rows: any[]) => {
  rows.forEach((item: any) => {
    item._replenishMoqErrorMin = undefined
  })
}

/** 获取补货 MOQ 分组 key。 */
const getReplenishMoqGroupKey = (row: any) => {
  /** 后端返回的报价组聚合 key。 */
  const groupKey = row?.replenishMoqInfo?.groupKey
  return groupKey ? String(groupKey) : ''
}

/** 获取补货 MOQ 最小数量。 */
const getReplenishMoqMinQuantity = (value: any) => {
  /** 后端返回的 MOQ 最小数量。 */
  const minQuantity = Number(value)
  return Number.isNaN(minQuantity) ? 0 : minQuantity
}

/** 根据 groupKey 聚合商品子表行。 */
const getReplenishMoqGroupMap = (rows: any[]) => {
  /** 商品子表按报价组聚合后的映射。 */
  const groupMap = new Map<string, any[]>()
  rows.forEach((item: any) => {
    /** 当前行报价组聚合 key。 */
    const groupKey = getReplenishMoqGroupKey(item)
    if (!groupKey) return
    /** 当前报价组内的商品行集合。 */
    const groupRows = groupMap.get(groupKey) ?? []
    groupRows.push(item)
    groupMap.set(groupKey, groupRows)
  })
  return groupMap
}

/** 设置补货 MOQ 错误提示。 */
const setReplenishMoqError = (row: any, minQuantity: number) => {
  if (!row || minQuantity <= 0) return
  /** 当前行已经记录的 MOQ 最小数量。 */
  const currentMinQuantity = getReplenishMoqMinQuantity(row._replenishMoqErrorMin)
  row._replenishMoqErrorMin = Math.max(currentMinQuantity, minQuantity)
}

/** 校验非多行分组的每行 MOQ，同时取行级与分组级最大值。 */
const validateReplenishRowMoq = (rows: any[], groupMap: Map<string, any[]>) => {
  /** 行级 MOQ 校验是否全部通过。 */
  let isValid = true
  rows.forEach((item: any) => {
    /** 当前行 MOQ 信息。 */
    const moqInfo = item?.replenishMoqInfo
    if (!moqInfo) return
    /** 当前行报价组聚合 key。 */
    const groupKey = getReplenishMoqGroupKey(item)
    /** 当前报价组内的商品行集合。 */
    const groupRows = groupKey ? groupMap.get(groupKey) ?? [] : []
    if (groupRows.length > 1) return
    /** 当前 SKU 行起订量。 */
    const rowMinOrderQuantity = getReplenishMoqMinQuantity(moqInfo.rowMinOrderQuantity)
    /** 当前报价组累计起订量。 */
    const groupMinOrderQuantity = getReplenishMoqMinQuantity(moqInfo.groupMinOrderQuantity)
    /** 当前行实际需要满足的最低起订量。 */
    const minOrderQuantity = Math.max(rowMinOrderQuantity, groupMinOrderQuantity)
    if (minOrderQuantity > 0 && getReplenishInputQuantity(item) < minOrderQuantity) {
      setReplenishMoqError(item, minOrderQuantity)
      isValid = false
    }
  })
  return isValid
}

/** 校验重复 groupKey 的报价组累计 MOQ，后端当前分组数量已达标时跳过分组提示。 */
const validateReplenishGroupMoq = (groupMap: Map<string, any[]>) => {
  /** 分组 MOQ 校验是否全部通过。 */
  let isValid = true
  groupMap.forEach((groupRows: any[]) => {
    if (groupRows.length <= 1) return
    /** 当前报价组累计起订量。 */
    const groupMinOrderQuantity = Math.max(...groupRows.map((item: any) => getReplenishMoqMinQuantity(item?.replenishMoqInfo?.groupMinOrderQuantity)))
    /** 后端返回的当前报价组已选数量。 */
    const groupCurrentQuantity = Math.max(...groupRows.map((item: any) => getReplenishMoqMinQuantity(item?.replenishMoqInfo?.groupCurrentQuantity)))
    if (groupCurrentQuantity >= groupMinOrderQuantity) return
    /** 当前报价组输入框累计数量。 */
    const groupInputQuantity = groupRows.reduce((total: number, item: any) => total + getReplenishInputQuantity(item), 0)
    if (groupMinOrderQuantity > 0 && groupInputQuantity < groupMinOrderQuantity) {
      groupRows.forEach((item: any) => setReplenishMoqError(item, groupMinOrderQuantity))
      isValid = false
    }
  })
  return isValid
}

/** 校验指定商品子表数据的补货 MOQ 是否满足后端规则。 */
const validateReplenishMoqRows = (rows: any[]) => {
  clearReplenishMoqErrors(rows)
  /** 当前商品子表 MOQ 分组映射。 */
  const groupMap = getReplenishMoqGroupMap(rows)
  /** 当前商品子表行级 MOQ 校验结果。 */
  const rowValid = validateReplenishRowMoq(rows, groupMap)
  /** 当前商品子表分组 MOQ 校验结果。 */
  const groupValid = validateReplenishGroupMoq(groupMap)
  return rowValid && groupValid
}

/** 获取当前行所在的 MOQ 校验范围。 */
const getCurrentReplenishMoqScopeRows = (row: any, rows: any[], groupMap: Map<string, any[]>) => {
  /** 当前行报价组聚合 key。 */
  const groupKey = getReplenishMoqGroupKey(row)
  /** 当前报价组内的商品行集合。 */
  const groupRows = groupKey ? groupMap.get(groupKey) ?? [] : []
  return groupRows.length > 1 ? groupRows : [row]
}

/** 判断当前行或当前分组是否存在 MOQ 错误。 */
const hasCurrentReplenishMoqError = (row: any, rows: any[]) => {
  /** 当前商品子表 MOQ 分组映射。 */
  const groupMap = getReplenishMoqGroupMap(rows)
  /** 当前行或当前分组需要关注的商品行集合。 */
  const currentRows = getCurrentReplenishMoqScopeRows(row, rows, groupMap)
  return currentRows.some((item: any) => !!item?._replenishMoqErrorMin)
}

/** 校验当前行或当前分组补货 MOQ 是否满足后端规则。 */
const validateReplenishMoq = (row: any, order: any) => {
  /** 当前订单展开商品子表数据。 */
  const rows = getChildTableRows(order, row)
  validateReplenishMoqRows(rows)
  return !hasCurrentReplenishMoqError(row, rows)
}

/** 处理补货数量输入，仅允许输入数字并实时刷新 MOQ 提示。 */
const changeInput = (row: any, order?: any) => {
  row.orderQuantity = String(row.orderQuantity ?? '').replace(/[^\d]/g, '')
  if (order) validateReplenishMoq(row, order)
}

const handleCombinDataListener = (data) => {
  if (!Array.isArray(data)) return
  const markItem = data?.find((item) => item?.platformOrderItemId === remarkData.value?.platformOrderItemId)
  if (markItem) {
    markItem.replaceFlag = true
    remarkData.value = {}
  }
}

/** 获取商品子表接口返回的总条数。 */
const getChildTableTotal = (data: any, apiData: any) => {
  /** 商品子表接口返回的总条数。 */
  const total = Number(apiData?.data?.total)
  return Number.isNaN(total) ? (Array.isArray(data) ? data.length : 0) : total
}

/** 根据商品子表是否只有一页数据控制当前子表分页是否隐藏。 */
const updateChildPaginationVisible = (data: any, row: any, apiData: any) => {
  if (!row) return
  /** 当前商品子表每页条数，用于判断是否只有一页。 */
  const pageLimit = Number(row?._pageData?.limit) || (Array.isArray(data) ? data.length : 0)
  row._hideChildPagination = pageLimit > 0 ? getChildTableTotal(data, apiData) <= pageLimit : false
}

/** 处理商品子表数据变化，并同步展开状态与 MOQ 提示状态。 */
const handleChildDataListener = (data, row, apiData) => {
  console.log(data, 'handleChildDataListener')

  updateChildPaginationVisible(data, row, apiData)
  if (!Array.isArray(data)) return
  validateReplenishMoqRows(data)
  const markItem = data?.find((item) => item?.platformOrderItemId === remarkData.value?.platformOrderItemId)
  data?.forEach(i => {
    if (Array.isArray(i.combinationOrderItemList)) {
      handleCombinDataListener(i.combinationOrderItemList)
    }
  })
  if (markItem && String(markItem.productType) === '1') {
    markItem.replaceFlag = true
    remarkData.value = {}
  }

  toggleExpandAllChange(row)
}

const handleReplaceGoods = (data) => {
  remarkData.value = { ...data }
  searchRef.value.setFormSearch({ platformOrderNoList: [data.platformOrderNo] })
}

const handleReplaceGoodsError = (data) => {
  SChildTableRefs.value[data?.platformOrderId].getData()
}

const searchRef = ref()
const handleReplaceWare = (data) => {
  searchRef.value.setFormSearch({ platformOrderNoList: [data] })
}

const openSendEmailDrawer = async (row: CustomerPlatformOrderRespDTO & {sendEmailLoading?: boolean}) => {
  if (row.sendEmailLoading) return
  const failedHistory = Array.isArray(row.emailHistoryList) ? row.emailHistoryList.find(item => item.status === 'FAILED') : undefined
  row.sendEmailLoading = true
  try {
    const res = await request.order.customer.platformOrderEmailPreview({
      customerShopId: row.customerShopId,
      platformOrderNo: row.platformOrderNo
    })
    if (!res.success || !res.data?.canPreview) {
      res.data?.reason && ElMessage.warning(res.data.reason)
      return
    }
    sendEmailDrawerRef.value?.open(buildOrderEmailRow(row, failedHistory, res.data))
  } finally {
    row.sendEmailLoading = false
  }
}

const buildOrderEmailRow = (row: CustomerPlatformOrderRespDTO, failedHistory?: PlatformOrderEmailHistoryRespDTO, preview?: PlatformOrderEmailPreviewRespDTO) => {
  const previewPayload = preview as PlatformOrderEmailPreviewPayload | undefined
  return {
    ...(failedHistory || {}),
    id: failedHistory?.id || row.emailHistoryId,
    platformOrderNo: failedHistory?.platformOrderNo || row.platformOrderNo,
    shopifyOrderNo: Number(row.orderSource) === 1 ? row.customerOrderNo : row.orderName,
    shopifyOrderName: failedHistory?.shopifyOrderName || row.orderName,
    processTime: failedHistory?.processTime || row.emailSendTime,
    status: failedHistory?.status || row.emailSendStatus,
    recipientEmail: previewPayload?.recipientEmail || failedHistory?.recipientEmail,
    subject: previewPayload?.subject || failedHistory?.subject,
    content: previewPayload?.content || failedHistory?.content,
    deliveryTaskCode: previewPayload?.deliveryTaskCode || failedHistory?.deliveryTaskCode,
    itemLoopContent: previewPayload?.itemLoopContent || failedHistory?.itemLoopContent,
    templateScene: previewPayload?.templateScene || failedHistory?.templateScene,
    customerShopId: previewPayload?.customerShopId || row.customerShopId,
    orderNo: previewPayload?.orderNo || row.orderName,
    items: previewPayload?.items,
    variableMap: previewPayload?.variableMap,
    mainCustomerId: row.mainCustomerId || row.customerId
  }
}

/** 处理显示时间 */
const dealRowEmail = (row:CustomerPlatformOrderRespDTO) => {
  if (Array.isArray(row.emailHistoryList)) {
    const error = row?.emailHistoryList?.find(i => i.status === 'FAILED')

    if (error) {
      return {
        state: 'error',
        msg: `${getJapanTime(error.processTime)} 送信失敗`,
        num: row?.emailHistoryList?.length
      }
    }
    return {
      state: 'success',
      msg: `${getJapanTime(row.emailHistoryList?.[0]?.processTime)} に送信済み`,
      num: row?.emailHistoryList?.length
    }
  } else {
    return {
      state: 'waiting',
      msg: '送信履歴なし',
      num: 0
    }
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommonTip, {
      name: _unref(isD2C)() ? 'stopPurchaseOrder,stopWarehouse' : 'stopPurchaseOrder'
    }, null, 8, ["name"]),
    _createElementVNode("div", {
      class: _normalizeClass(["order-list", 'order-list-' + _unref(useSite)()])
    }, [
      (orderNumObj.value?.waitPayCount > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(orderNumObj.value.waitPayCount > 99 ? '99+' : orderNumObj.value.waitPayCount), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_el_tabs, {
        modelValue: _unref(tabData),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabData) ? (tabData).value = $event : null)),
        type: "card",
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabList), (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.name,
              label: item.title,
              name: item.name
            }, null, 8, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(SSearch, {
        ref: (_value, _refs) => {
          _refs['searchRef'] = _value
          searchRef.value = _value
        },
        form: _unref(orderForm),
        "onUpdate:form": [
          _cache[1] || (_cache[1] = ($event: any) => (_isRef(orderForm) ? (orderForm).value = $event : null)),
          search
        ],
        isTiktok: _unref(isTiktok),
        states: _unref(platformOrderStatus),
        isShopify: isShopify.value,
        isWhiteUser: isWhiteUser.value,
        onResetForm: _cache[2] || (_cache[2] = ($event: any) => (isFilterData.value = false))
      }, null, 8, ["form", "isTiktok", "states", "isShopify", "isWhiteUser"]),
      _createElementVNode("div", _hoisted_2, [
        (_unref(tabData) !== '2')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (exportOrder(1))),
              loading: exportLoading.value,
              style: {"margin":"25px 30px 25px 14px"},
              disabled: _unref(exportNum) === 0 && _unref(tableCount) === 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('导出订单')) + " ", 1),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(exportNum))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_unref(t)('已勾选')) + "：" + _toDisplayString(_unref(exportNum)) + ")", 1))
                        : (_unref(tableCount) && isFilterData.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_unref(t)('已筛选')) + "：" + _toDisplayString(_unref(tableCount)) + ")", 1))
                          : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: batchPay,
              style: {"margin":"25px 30px 25px 14px"},
              disabled: _unref(selectedOrderList).length === 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('批量付款')) + " ", 1),
                (_unref(selectedOrderList).length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(_unref(selectedOrderList).length) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"])),
        (_unref(isD2C)())
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              onClick: batchPriorityDelivery,
              style: {"margin":"25px 30px 25px 14px"},
              disabled: _unref(selectedOrderList).length === 0
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  placement: "top",
                  effect: "light",
                  "hide-after": 30
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('请将优先发货筛选项改为是后操作1')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(SvgIcon, { name: "Warning" })
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('批量优先发货')), 1),
                (_unref(selectedOrderList).length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(" + _toDisplayString(_unref(selectedOrderList).length) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_unref(tabData) !== '2' && _unref(is3RDCustomerShop)())
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (exportOrder(2))),
              loading: exportLoading.value,
              style: {"margin":"25px 30px 25px 14px"},
              disabled: _unref(exportNum) === 0 && _unref(tableCount) === 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('API订单导出')) + " ", 1),
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(exportNum))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(_unref(t)('已勾选')) + "：" + _toDisplayString(_unref(exportNum)) + ")", 1))
                        : (_unref(tableCount) && isFilterData.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString(_unref(t)('已筛选')) + "：" + _toDisplayString(_unref(tableCount)) + ")", 1))
                          : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true),
        (_unref(emailSetting)?.whitelistEnabled)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 4,
              type: "text",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('SendEmailList')))),
              style: {"margin":"25px 30px 25px 14px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('メールの送信履歴')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            _isRef(STableRef) && (STableRef.value = _value)
          },
          "page-data": _unref(pageData),
          "onUpdate:page-data": _cache[10] || (_cache[10] = ($event: any) => (_isRef(pageData) ? (pageData).value = $event : null)),
          api: _unref(getPlatformOrder),
          filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
          columns: _unref(columns),
          tableConfig: parentTableConfig,
          "row-class-name": orderClassName,
          onSelectionChange: _unref(handleSelectionChange),
          onExpandRow: _unref(handleExpandRow),
          onExpandAll: _unref(handleExpandAll),
          onDataListener: dataListenerFn,
          showTableFilter: true,
          defaultFilterKey: "orderList"
        }, {
          emailHistoryList: _withCtx(({row}) => [
            (row.platformOrderType==1&&row.orderSource== 1||row.orderSource== 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (dealRowEmail(row).num)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: _normalizeClass(dealRowEmail(row).state)
                        }, _toDisplayString(dealRowEmail(row).msg), 3),
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('SendEmailList',{query:{platformOrderNo:row.platformOrderNo}}))),
                          class: "sendNum"
                        }, _toDisplayString(row.emailHistoryList?.length) + "回送信", 9, _hoisted_13)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, "-"))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, "-"))
          ]),
          platformOrderSettleStatusHead: _withCtx(() => [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_unref(t)('订单是否结算')) + " ", 1),
              _createVNode(_component_el_tooltip, {
                effect: "light",
                placement: "top"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('当商品状态更改为“已检”和“已取消”，则会清算指定的商品金额，订单的所有商品状态更改为“已清算”，则订单清算完成')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ]),
          wareCode: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.wareCode === _unref(jpWareInfo).warehouseCode ? _unref(t)('日本') : _unref(t)('中国')), 1)
          ]),
          rtsSlaTime: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_18, _toDisplayString(!isNaN(+row.rtsSlaTime) ? _unref(dayjs)(row.rtsSlaTime * 1000).format('YYYY-MM-DD HH:mm:ss') : '-'), 1)
          ]),
          payInfoSlot: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (row.totalSettleAmount !== null && row.totalSettleAmount !== '-')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, [
                        _createTextVNode(_toDisplayString(_unref(t)('结算金额')) + " ", 1),
                        _createVNode(_component_el_tooltip, {
                          effect: "light",
                          placement: "top",
                          "popper-class": "tool-tip-no-border"
                        }, {
                          content: _withCtx(() => [
                            (!row.tags.includes(4))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createTextVNode(_toDisplayString(_unref(t)('结算金额')) + " = " + _toDisplayString(_unref(t)('商品金额')) + " + " + _toDisplayString(_unref(t)('商品附加项费用')) + " + " + _toDisplayString(_unref(t)('国内运费')) + " + " + _toDisplayString(_unref(t)('代购手续费')) + " ", 1),
                                  (row.platformOrderType == '1')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, " + " + _toDisplayString(_unref(isTiktok) && row.platformOrderType === 1 && row.wareCode === _unref(jpWareInfo).warehouseCode ?
                            '日本国内送料' : _unref(t)('国际运费')), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(t)('合计额（清算后）=实际清算数量*全包单价')), 1))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionFilled), { style: {"height":"14px","transform":"translateY(3px)"} })
                          ]),
                          _: 2
                        }, 1024),
                        _hoisted_26
                      ]),
                      ((row.platformOrderType == '1' && row.wareCode == _unref(jpWareInfo).warehouseCode))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(row.totalSettleAmount) + "円", 1))
                        : (row.tags.includes(4))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(row.totalSettleAmountJpy) + "円 ", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(showPriceAndUnit)(row.totalSettleAmount ??
                    '-',
                    _unref(showCurrentUnit)(_unref(COUNTRY).KR ===
                      row.deliveryCountry))), 1))
                    ]))
                  : (row.totalFreezeAmount !== '-')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (row.tags.includes(4))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)('交易金额')) + "：", 1),
                              _createElementVNode("span", null, _toDisplayString(row.totalFreezeAmountJpy) + "円" + _toDisplayString(_unref(isWhiteHiddenRMB)() ? '' :
                    `(${row.totalFreezeAmount}元)`), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('冻结金额')) + "：", 1),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(showPriceAndUnit)(row.totalFreezeAmount, _unref(showCurrentUnit)(_unref(COUNTRY).KR
                    ===
                    row.deliveryCountry))), 1),
                              (row.productAdditionFreezeAmount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)('商品附加项费用')) + "：", 1),
                                    _createElementVNode("span", null, _toDisplayString(_unref(showPriceAndUnit)(row.productAdditionFreezeAmount, _unref(showCurrentUnit)(_unref(COUNTRY).KR ===
                      row.deliveryCountry))), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (row.stageInfos.length && row.stageInfos !== '-')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.stageInfos, (item) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "pay-info-list",
                                        key: item.stageNo
                                      }, [
                                        _createElementVNode("div", _hoisted_36, [
                                          _createElementVNode("div", null, [
                                            (item.stageNo)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_unref(t)('X期金额').replace('X',
                            `${item.stageNo}/${row.stageInfos.length} `)) + "(" + _toDisplayString(item.freezeRate) + ")", 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(item.freezeStatus === 2 ? 'font-red' : '')
                                            }, _toDisplayString(_unref(showPriceAndUnit)(item.freezeAmount?.toFixed(2),
                              _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.deliveryCountry))), 3)
                                          ]),
                                          _createElementVNode("div", null, [
                                            (item.freezeStatus === 3)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(t)('已支付')), 1))
                                              : _createCommentVNode("", true),
                                            (item.freezeStatus === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(t)('本期支付')), 1))
                                              : _createCommentVNode("", true),
                                            ([1, 4].includes(item.freezeStatus))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_unref(t)('待支付')), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]))
                    : _createCommentVNode("", true)
              ])
            ])
          ]),
          expand: _withCtx(({ scope }) => [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(STable, {
                "max-height": "400px",
                class: "productTable",
                ref: (el) => _unref(SChildTableRefs)[scope.row.platformOrderId] = el,
                "page-data": scope.row._pageData,
                "onUpdate:page-data": ($event: any) => ((scope.row._pageData) = $event),
                api: _unref(getPlatformOrderItemPage),
                filterData: { platformOrderId: scope.row.platformOrderId, source: 1 },
                page_position: "left",
                columns: getChildColumns(_unref(childColumns), scope.row),
                tableConfig: _unref(childConfig),
                isImmediatelyExec: false,
                showPagination: !scope.row._hideChildPagination,
                onDataListener: (data, apiData) => handleChildDataListener(data, scope.row, apiData)
              }, {
                customerOrderNo: _withCtx(({ row }) => [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('SyncOrder', { query: { [_unref(store).getters?.shopInfo?.customerShopPlatform === 11 ? 'shopOrderNo' : 'orderName']: row.customerOrderNo, orderSyncStatus: 1 } })))
                  }, _toDisplayString(row.customerOrderNo), 9, _hoisted_42)
                ]),
                operate: _withCtx(({ row }) => [
                  (_unref(isD2C)() && row.orderItemStatusList.find(i => [14, 15].includes(i.orderItemStatus)) && row.productType !== 3 && _unref(isReplaceWhiteUser))
                    ? (_openBlock(), _createBlock(_component_table_button, {
                        key: 0,
                        title: _unref(t)('引当振替処理'),
                        onClick: _withModifiers(($event: any) => (replaceGoodsRef.value.show({ ...row, platformOrderNo: scope.row.platformOrderNo })), ["stop"])
                      }, null, 8, ["title", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                settleStatus: _withCtx(({ row }) => [
                  (row.virtualFlag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, " - "))
                    : ([1, 2].includes(row.settleStatus))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_unref(t)('未结算')), 1))
                      : (row.settleStatus === 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_unref(t)('已结算')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_46, "-"))
                ]),
                abnormalSlot: _withCtx(({ row }) => [
                  (row?.untreatedNum > 0 || row?.processedNum > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        (row?.untreatedNum > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "abnormal-jump",
                              onClick: _withModifiers(($event: any) => (jumpAbnormalOrder(row, 'goods', 1, scope.row)), ["stop"])
                            }, _toDisplayString(_unref(t)('未处理')) + "（" + _toDisplayString(row.untreatedNum) + "）>", 9, _hoisted_48))
                          : _createCommentVNode("", true),
                        _hoisted_49,
                        (row?.processedNum > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              class: "abnormal-jump",
                              onClick: _withModifiers(($event: any) => (jumpAbnormalOrder(row, 'goods', 0, scope.row)), ["stop"])
                            }, _toDisplayString(_unref(t)('已处理')) + "（" + _toDisplayString(row.processedNum) + "）>", 9, _hoisted_50))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_51, "-"))
                ]),
                purchaseCountry: _withCtx(({ row }) => [
                  (row.productType != 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_unref(countryCodeNameMap).get(row.purchaseCountry)), 1))
                    : _createCommentVNode("", true)
                ]),
                actualProductSellPrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1)
                ]),
                actualTotalProductSellPrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualTotalProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR ===
                    row.goodsCountry))), 1)
                ]),
                expand: _withCtx(({ scope: scopeChild }) => [
                  _createVNode(STable, {
                    class: "combinationTable",
                    "table-data": scopeChild.row.combinationOrderItemList,
                    columns: getChildColumns(_unref(childColumns), scope.row),
                    tableConfig: _unref(childConfig),
                    showPagination: false,
                    onRowClick: (row) => { row.productType !== 3 && jump(_unref(useRtfix)('ProductInfo', { query: { platformOrderItemId: row.platformOrderItemId, productType: row.productType, isGroup: scopeChild.row.productType === 3, combineSku: scope.row.separateFlag === 0 ? scopeChild.row.productSku : '' } })) },
                    onDataListener: _cache[7] || (_cache[7] = (data) => handleCombinDataListener(data))
                  }, {
                    operate: _withCtx(({ row }) => [
                      (_unref(isD2C)() && row.orderItemStatusList.find(i => [14, 15].includes(i.orderItemStatus)) && row.productType !== 3 && _unref(isReplaceWhiteUser))
                        ? (_openBlock(), _createBlock(_component_table_button, {
                            key: 0,
                            title: _unref(t)('引当振替処理'),
                            onClick: _withModifiers(($event: any) => (replaceGoodsRef.value.show({ ...row, platformOrderNo: scope.row.platformOrderNo })), ["stop"])
                          }, null, 8, ["title", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    abnormalSlot: _withCtx(({ row }) => [
                      (row?.untreatedNum > 0 || row?.processedNum > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            (row?.untreatedNum > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "abnormal-jump",
                                  onClick: _withModifiers(($event: any) => (
                        jumpAbnormalOrder(row, 'goods', 1, scope.row)
                        ), ["stop"])
                                }, _toDisplayString(_unref(t)('未处理')) + "（" + _toDisplayString(row.untreatedNum) + "）>", 9, _hoisted_54))
                              : _createCommentVNode("", true),
                            _hoisted_55,
                            (row?.processedNum > 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "abnormal-jump",
                                  onClick: _withModifiers(($event: any) => (
                        jumpAbnormalOrder(row, 'goods', 0, scope.row)
                        ), ["stop"])
                                }, _toDisplayString(_unref(t)('已处理')) + "（" + _toDisplayString(row.processedNum) + "）>", 9, _hoisted_56))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_57, "-"))
                    ]),
                    purchaseCountry: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.purchaseCountry)), 1)
                    ]),
                    settleStatus: _withCtx(({ row }) => [
                      (row.virtualFlag)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, " - "))
                        : ([1, 2].includes(row.settleStatus))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_unref(t)('未结算')), 1))
                          : (row.settleStatus === 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_unref(t)('已结算')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_61, "-"))
                    ]),
                    shoppingInfo: _withCtx(({ row }) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", {
                          class: "flex-ter",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createVNode(GoodsLink, {
                            goods: row,
                            class: "fx-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(ShoppingPreview, {
                                image: getImage(
                            row.productSkuImg || row.productMainImg || ''
                          )
                            ,
                                name: row.productTitleJp || ''
                              }, null, 8, ["image", "name"])
                            ]),
                            _: 2
                          }, 1032, ["goods"])
                        ]),
                        (row.replaceFlag)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              style: {"margin-top":"10px"},
                              type: "danger"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_62
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (row.tags?.includes(15))
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              style: {"margin-top":"10px"},
                              type: "success"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_63
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    productSku: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_el_tooltip, {
                            content: _unref(t)(
                          'クリックすると、商品の作業履歴をご確認いただけます！'
                        )
                          ,
                            placement: "top",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              row
                                ? (_openBlock(), _createBlock(ProductSku, {
                                    key: 0,
                                    row: row,
                                    productType: row.productType,
                                    isGroup: scopeChild.row.productType === 3,
                                    combineSku: scope.row.separateFlag === 0
                              ? scopeChild.row.productSku
                              : ''
                              
                                  }, null, 8, ["row", "productType", "isGroup", "combineSku"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ]),
                        _createVNode(CopyButton, {
                          text: _unref(supportCombineAutoAddTk) && row.productSku?.endsWith('-tk') ? row?.productSku?.slice(0, -3) : row?.productSku
                        }, null, 8, ["text"])
                      ]),
                      (row.tags?.includes(14))
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            style: {"margin-top":"10px"},
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_66
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    averagePrice: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(getAveragePrice(row)), 1)
                    ]),
                    final: _withCtx(({ row }) => [
                      (row.settlePriceList?.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList.reduce(
                          (total, v): number => {
                            return total + v.price
                          },
                          0
                        ), _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1))
                        : _createCommentVNode("", true),
                      (row.settlePriceList?.length > 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _withModifiers(($event: any) => (checkFinalPrice(row)), ["stop"]),
                            style: {"color":"#1890ff","cursor":"pointer"}
                          }, _toDisplayString(_unref(t)('查看详情')), 9, _hoisted_68))
                        : (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList?.[0]?.price
                          ? row.settlePriceList?.[0]?.price
                          : '-', _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1))
                    ]),
                    finalHead: _withCtx(() => [
                      _createElementVNode("div", _hoisted_70, _toDisplayString(_unref(t)('最终采购价')), 1)
                    ]),
                    productPropertiesName: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_71, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(
                        ';'
                      ), (prop) => {
                          return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                        }), 128))
                      ])
                    ]),
                    shoppingStats: _withCtx(({ row }) => [
                      row
                        ? (_openBlock(), _createBlock(ProductStats, {
                            key: 0,
                            row: row,
                            cancelJump: true,
                            orderNo: scope.row.platformOrderNo,
                            combineSku: scope.row.separateFlag === 0
                        ? scopeChild.row.productSku
                        : ''
                        ,
                            isReplenish: row.smartReplenishFlag
                          }, null, 8, ["row", "orderNo", "combineSku", "isReplenish"]))
                        : _createCommentVNode("", true)
                    ]),
                    channel: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_72, [
                        (row.productType === 3)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_unref(t)('组合')), 1)
                            ], 64))
                          : (row.productType === 2)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_unref(t)('OEM')), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(_unref(channelEnum)[row.channel] || '-'), 1)
                              ], 64))
                      ])
                    ]),
                    platformOrderItemAdditionDTOList: _withCtx(({ row }) => [
                      (
                      row.platformOrderItemAdditionDTOList &&
                      row.platformOrderItemAdditionDTOList !== '-'
                    )
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            effect: "light",
                            placement: "top"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(montageAddition)(
                              row.platformOrderItemAdditionDTOList
                            )), 1)
                            ]),
                            default: _withCtx(() => [
                              (row.platformOrderItemAdditionDTOList !== '-')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("span", _hoisted_75, "-")),
                      (
                      scope.row.orderSource === 6 &&
                      _unref(tabData) === '2' &&
                      row.productType === 1
                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                            _createElementVNode("a", {
                              onClick: _withModifiers(($event: any) => (openAddition(row, scope.row)), ["stop"])
                            }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_77)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    goodsCountry: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.goodsCountry)), 1)
                    ]),
                    actualProductSellPrice: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1)
                    ]),
                    actualTotalProductSellPrice: _withCtx(({ row }) => [
                      _createElementVNode("div", null, _toDisplayString(_unref(showPriceAndUnit)(row.actualTotalProductSellPrice, _unref(showCurrentUnit)(_unref(COUNTRY).KR ===
                        row.goodsCountry))), 1)
                    ]),
                    _: 2
                  }, 1032, ["table-data", "columns", "tableConfig", "onRowClick"])
                ]),
                platformOrderItemAdditionDTOList: _withCtx(({ row }) => [
                  (
                  row.platformOrderItemAdditionDTOList &&
                  row.platformOrderItemAdditionDTOList !== '-'
                )
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        effect: "light",
                        placement: "top"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_78, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_79, _toDisplayString(_unref(montageAddition)(row.platformOrderItemAdditionDTOList)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createElementBlock("span", _hoisted_80, "-")),
                  (
                  ((scope.row.orderSource === 6 || scope.row.orderSource === 10 || scope.row.tags.includes(7)) &&
                  scope.row.platformOrderStatus === 2 &&
                  // 17为小单快反品
                  (row.productType === 1||row.oemBusinessType===2))||(scope.row.tags.includes(17)&&scope.row.platformOrderStatus === 2)
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _withDirectives(_createVNode(_component_el_radio, {
                          "model-value": row.noAdditionalFlag === 1,
                          size: "small",
                          label: true,
                          style: {"margin-right":"0"},
                          onClick: _cache[8] || (_cache[8] = _withModifiers(() => { }, ["stop"])),
                          onChange: ($event: any) => (noAdd(row, scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                          ]),
                          _: 2
                        }, 1032, ["model-value", "onChange"]), [
                          [_vShow, !row.platformOrderItemAdditionDTOList?.length || row.platformOrderItemAdditionDTOList === '-']
                        ]),
                        _createElementVNode("a", {
                          onClick: _withModifiers(($event: any) => (openAddition(row, scope.row)), ["stop"])
                        }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_82),
                        _withDirectives(_createElementVNode("div", { class: "add-valid-text" }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                          [_vShow, (row.platformOrderItemAdditionDTOList === '-' && row.noAdditionalFlag !== 1)]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (scope.row.tags?.includes(7) && scope.row.platformOrderStatus === 2&&row.oemBusinessType!=2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        _createVNode(_unref(Warning), { class: "icon" }),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('商品附加项是取店铺默认配置，请重新确认是否调整')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                shoppingInfo: _withCtx(({ row }) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_84, [
                      (row.productType !== 3)
                        ? (_openBlock(), _createBlock(GoodsLink, {
                            key: 0,
                            goods: row
                          }, {
                            default: _withCtx(() => [
                              _createVNode(ShoppingPreview, {
                                image: getImage(row.productSkuImg || row.productMainImg || ''),
                                name: row.productTitleJp || ''
                              }, null, 8, ["image", "name"])
                            ]),
                            _: 2
                          }, 1032, ["goods"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                            _createVNode(ShoppingPreview, {
                              image: getImage(row.productMainImg || '')
                            }, null, 8, ["image"]),
                            _createElementVNode("p", null, _toDisplayString(row.productTitleJp), 1)
                          ])),
                      (row.productType === 3 && _unref(isD2C)())
                        ? (_openBlock(), _createElementBlock("img", _hoisted_86))
                        : _createCommentVNode("", true),
                      (row.priorityShippingStatus && _unref(isD2C)())
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 3,
                            referrerPolicy: "no-referrer",
                            src: `${imgHeader}d2c-${_unref(useSite)()}.png`,
                            style: {"margin-left":"10px","width":"50px"},
                            class: "order-tag"
                          }, null, 8, _hoisted_87))
                        : _createCommentVNode("", true),
                      (row.productType === 3 && !_unref(isD2C)())
                        ? (_openBlock(), _createElementBlock("img", _hoisted_88))
                        : _createCommentVNode("", true),
                      (row.priorityShippingStatus && !_unref(isD2C)())
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 5,
                            referrerPolicy: "no-referrer",
                            src: `${imgHeader}b2b-${_unref(useSite)()}.png`,
                            style: {"margin-left":"10px","width":"50px"},
                            class: "order-tag"
                          }, null, 8, _hoisted_89))
                        : _createCommentVNode("", true)
                    ]),
                    (row.replaceFlag)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          style: {"margin-top":"10px"},
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_90
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (row.tags?.includes(15))
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 1,
                          style: {"margin-top":"10px"},
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_91
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                productSku: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      (row.productType !== 3)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            content: _unref(t)('クリックすると、商品の作業履歴をご確認いただけます！'),
                            placement: "top",
                            effect: "light"
                          }, {
                            default: _withCtx(() => [
                              row
                                ? (_openBlock(), _createBlock(ProductSku, {
                                    key: 0,
                                    row: row,
                                    productType: row.productType,
                                    tooltip: true
                                  }, null, 8, ["row", "productType"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["content"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            row
                              ? (_openBlock(), _createBlock(ProductSku, {
                                  key: 0,
                                  row: row,
                                  productType: row.productType,
                                  tooltip: true
                                }, null, 8, ["row", "productType"]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]),
                    _createVNode(CopyButton, {
                      text: _unref(supportCombineAutoAddTk) && row.productSku?.endsWith('-tk') ? row?.productSku?.slice(0, -3) : row?.productSku
                    }, null, 8, ["text"])
                  ]),
                  (row.tags?.includes(14))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        style: {"margin-top":"10px","color":"#f0b211"},
                        type: "warning"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_94
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (row.oemBusinessType==2&&scope.row.platformOrderStatus == 2&&scope.row.tags?.includes(7))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        style: {"margin-top":"10px","color":"#f0b211"},
                        type: "warning"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('oem生产')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                averagePrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(getAveragePrice(row)), 1)
                ]),
                final: _withCtx(({ row }) => [
                  (row.settlePriceList?.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList.reduce((total, v): number => {
                    return _unref(getTrueNumber)(total + v.price)
                  }, 0), _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1))
                    : _createCommentVNode("", true),
                  (row.settlePriceList?.length > 1 && (row.productType !== 3))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _withModifiers(($event: any) => (checkFinalPrice(row)), ["stop"]),
                        style: {"color":"#1890FF","cursor":"pointer"}
                      }, _toDisplayString(_unref(t)('查看详情')), 9, _hoisted_96))
                    : (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(_unref(showPriceAndUnit)(row.settlePriceList?.[0]?.price && (row.productType !== 3) ?
                  row.settlePriceList?.[0]?.price : '-', _unref(showCurrentUnit)(_unref(COUNTRY).KR === row.goodsCountry))), 1))
                ]),
                finalHead: _withCtx(() => [
                  _createElementVNode("div", _hoisted_98, _toDisplayString(_unref(t)('最终采购价')), 1)
                ]),
                productPropertiesName: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_99, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productPropertiesName || '').split(';'), (prop) => {
                      return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                    }), 128))
                  ])
                ]),
                shoppingStats: _withCtx(({ row }) => [
                  (row.virtualFlag)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_100, " - "))
                    : (row.productType === 3)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "text",
                          onClick: _withModifiers(($event: any) => (openCombinationVisible(row)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(combinationStatusDict)[row.combinationStatus]), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          row
                            ? (_openBlock(), _createBlock(DocumentaryRecord, {
                                key: 0,
                                row: row,
                                cancelJump: true,
                                orderNo: scope.row.platformOrderNo,
                                showExpress: true,
                                onOpen: openExpress,
                                isReplenish: row.smartReplenishFlag
                              }, null, 8, ["row", "orderNo", "isReplenish"]))
                            : _createCommentVNode("", true)
                        ], 64))
                ]),
                channel: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_101, [
                    (row.productType === 3)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(t)('组合')), 1)
                        ], 64))
                      : (row.productType === 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(t)('OEM')), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_unref(channelEnum)[row.channel] || '-'), 1)
                          ], 64))
                  ])
                ]),
                cancelProgress: _withCtx(({ row }) => [
                  (row.cancelProgress === 1 || row.cancelProgress === 2)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (jumpCancel(row, scope.row)), ["stop"])
                      }, _toDisplayString(_unref(t)('取消成功')), 9, _hoisted_102))
                    : (_openBlock(), _createElementBlock("span", _hoisted_103, "-"))
                ]),
                feeInfo: _withCtx(({ row }) => [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (_ctx.$router.push(_unref(useRtfix)('StoreFund', { query: { platformOrderNo: scope.row.platformOrderNo, currencyCode: row.currencyCode } }))), ["stop"])
                  }, _toDisplayString(_unref(t)('查看')), 9, _hoisted_104)
                ]),
                purchasingFee: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(row.purchasingFee === '-' ? row.stallHandlingFee : row.purchasingFee), 1)
                ]),
                allIncludeProductPrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(`${row.allIncludePriceResultDetail?.allIncludeProductPriceExchange}円`) + _toDisplayString((_unref(isWhiteHiddenRMB)() && row.allIncludePriceResultDetail?.allIncludeType === 2) ? '' :
                    `(${row.allIncludePriceResultDetail?.allIncludeProductPrice}元)`), 1),
                  _createVNode(AllPriceDetail, {
                    detail: row.allIncludePriceResultDetail,
                    season: row.season,
                    transportType: scope.row.transportType
                  }, null, 8, ["detail", "season", "transportType"])
                ]),
                allIncludeProductTotalPrice: _withCtx(({ row }) => [
                  (scope.row.platformOrderSettleStatus === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(`${(row.allIncludePriceResultDetail?.allIncludeProductPriceExchange *
                    row.settlementQuantity).toFixed(0)}円`) + _toDisplayString((_unref(isWhiteHiddenRMB)() && row.allIncludePriceResultDetail?.allIncludeType === 2) ? '' :
                    `(${(row.allIncludePriceResultDetail?.allIncludeProductPrice * row.settlementQuantity).toFixed(2)}元)`), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_106, "-"))
                ]),
                feeDetail: _withCtx(() => [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('StoreFund', { query: { platformOrderNo: scope.row.platformOrderNo } })))
                  }, _toDisplayString(_unref(t)('查看资金流水')), 9, _hoisted_107)
                ]),
                quantity: _withCtx(({ row }) => [
                  _createElementVNode("div", null, [
                    (scope.row.platformOrderStatus === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                          _createVNode(_component_el_input, {
                            size: "small",
                            modelValue: row.orderQuantity,
                            "onUpdate:modelValue": ($event: any) => ((row.orderQuantity) = $event),
                            onBlur: ($event: any) => (handleRecommendReplenishQuantityBlur(row, scope.row, _unref(SChildTableRefs)[scope.row.platformOrderId].tableData?.length > 1 ? 0 : 1)),
                            onInput: ($event: any) => (changeInput(row, scope.row))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onInput"]),
                          (row._replenishMoqErrorMin)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                (row?.replenishMoqInfo?.searchSourcePriceType==3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, " カラーごとの最低ロット数は" + _toDisplayString(row._replenishMoqErrorMin) + "です ", 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_111, " 最低ロット数：" + _toDisplayString(row._replenishMoqErrorMin) + "枚 ", 1))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(row.orderQuantity), 1))
                  ])
                ]),
                _: 2
              }, 1032, ["page-data", "onUpdate:page-data", "api", "filterData", "columns", "tableConfig", "showPagination", "onDataListener"])
            ])
          ]),
          platformOrderDeliveryAdditionalList: _withCtx(({ row }) => [
            (row.platformOrderDeliveryAdditionalList && row.platformOrderDeliveryAdditionalList !== '-')
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "light",
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_113, _toDisplayString(row.platformOrderDeliveryAdditionalList.map((v) => {
                  return v.additionNameJp
                }).join(',')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_114, _toDisplayString(row.platformOrderDeliveryAdditionalList.map((v) => {
                return v.additionNameJp
              }).join(',')), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createElementBlock("span", _hoisted_115, "-")),
            (row.orderSource === 6 && _unref(tabData) === '2')
              ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                  _createElementVNode("a", {
                    onClick: _withModifiers(($event: any) => (openDt(row)), ["stop"])
                  }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_117)
                ]))
              : _createCommentVNode("", true)
          ]),
          platformOrderNo: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  (row.interceptFlag === 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: `https://static-s.theckb.com/BusinessMarket/icon/reserve_${_unref(useSite)()}.png`,
                        class: "interceptFlag"
                      }, null, 8, _hoisted_121))
                    : _createCommentVNode("", true),
                  (row.platformOrderId)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _withModifiers(($event: any) => (jump(_unref(useRtfix)('OrderInfo', { params: { id: row.platformOrderId }, query: { type: row.orderSource !== 1 ? 1 : '' } }))), ["stop"])
                      }, _toDisplayString(row.platformOrderNo), 9, _hoisted_122))
                    : (_openBlock(), _createElementBlock("span", _hoisted_123, _toDisplayString(row.platformOrderNo), 1))
                ]),
                _createVNode(CopyButton, {
                  text: row.platformOrderNo
                }, null, 8, ["text"])
              ]),
              (row.tags?.includes(7))
                ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                    _createElementVNode("span", _hoisted_125, _toDisplayString(_unref(t)('API自动补货订单')), 1)
                  ]))
                : _createCommentVNode("", true),
              (row.tags?.includes(14))
                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                    _createVNode(_component_el_tag, { type: "warning" }, {
                      default: _withCtx(() => [
                        _hoisted_127
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (row.tags?.includes(10))
                ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                    _createVNode(SvgIcon, {
                      name: "Tips_提示",
                      style: {"font-size":"16px","margin-right":"6px"}
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('已取消')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_space, { direction: "vertical" }, {
                default: _withCtx(() => [
                  (_unref(isD2C)() && row.useOneTheWayInventoryFlag === 1)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        style: {"margin-top":"4px"},
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('在途抵用')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isD2C)() && row.tags?.includes(6))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        style: {"margin-top":"4px"},
                        type: "warning"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_129
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (row.tags?.includes(15))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        style: {"margin-top":"4px"},
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_130
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (row.tags?.includes(8))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 3,
                        style: {"margin-top":"4px"},
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('海外备货')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (row.tags?.includes(9) && isWhiteUser.value)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 4,
                        style: {"margin-top":"4px"},
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_131
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isD2C)() && row.tags?.includes(12))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 5,
                        style: {"margin-top":"4px"},
                        type: "warning"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_132
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (row.tags?.includes(13))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 6,
                        style: {"margin-top":"4px"},
                        type: "warning"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_133
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          customerOrderNo: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_134, [
              (!row.edit)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "light",
                    placement: "top"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_135, _toDisplayString(row.customerOrderNo), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_136, _toDisplayString(row.customerOrderNo), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_component_el_input, {
                    key: 1,
                    modelValue: row.customerOrderNo,
                    "onUpdate:modelValue": ($event: any) => ((row.customerOrderNo) = $event),
                    maxlength: "30"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])),
              (row.customerOrderNo !== '-' && !row.edit)
                ? (_openBlock(), _createBlock(CopyButton, {
                    key: 2,
                    text: row.customerOrderNo
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ]),
            (!row.tags?.includes(12))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!row.edit)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: ($event: any) => {row.customerOrderNo = row.customerOrderNo === '-' ? '' : row.customerOrderNo; row.edit = true},
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: ($event: any) => (saveCustomerNo(row)),
                        size: "small",
                        loading: row.loading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "loading"]))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          orderName: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("span", null, _toDisplayString(row.orderName), 1),
              (row.orderName !== '-')
                ? (_openBlock(), _createBlock(CopyButton, {
                    key: 0,
                    text: row.orderName
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          orderSource: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(orderSourceEnum)[row.orderSource]), 1)
          ]),
          platformOrderType: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_138, _toDisplayString(row.tags.includes(4) ? (_unref(isD2C)() ? _unref(t)('直发订单(一口价)') : _unref(t)('囤货订单(一口价)')) :
            _unref(platformOrderTypeEnum)[row.platformOrderType]), 1)
          ]),
          createTime: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
          ]),
          inShippingInfo: _withCtx(({ row }) => [
            (_unref(isD2C)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                  (row.deliverStatus === 1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _withModifiers(($event: any) => (international(row)), ["stop"])
                      }, _toDisplayString(_unref(t)('详情')), 9, _hoisted_140))
                    : (row.orderSource === 6 && _unref(tabData) === '2')
                      ? (_openBlock(), _createBlock(ExpressSelect, {
                          key: 1,
                          id: row.intShipConfigId,
                          "onUpdate:id": ($event: any) => ((row.intShipConfigId) = $event),
                          getData: () => getExpressData(row),
                          beforeSave: (id) => changeLogistics(row, id),
                          defaultExpress: batchExpressList.value[row.wareCountry],
                          className: 'express-select-' + row.platformOrderId,
                          countryCode: row.deliveryCountry
                        }, null, 8, ["id", "onUpdate:id", "getData", "beforeSave", "defaultExpress", "className", "countryCode"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_141, _toDisplayString(batchExpressList.value[row.wareCountry]?.find((v) =>
                v.intShipConfigId === row.intShipConfigId)?.distribution ?? (row.tags?.includes(4) ? row.transportType ===
                  1 ? _unref(t)('海运') : _unref(t)('空运') : '-')), 1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_142, [
                  (row.tags?.includes(4))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                        _createTextVNode(_toDisplayString(row.transportType === 1 ? _unref(t)('海运') : _unref(t)('空运')) + " ", 1),
                        (row.totalFreezeAmountJpy >= 150000 && row.platformOrderStatus === 2)
                          ? (_openBlock(), _createBlock(SelectTransport, {
                              key: 0,
                              transportType: row.transportType,
                              onChange: (type) => changeTransportType(row.platformOrderId, type)
                            }, null, 8, ["transportType", "onChange"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_144, "-"))
                ]))
          ]),
          handler: _withCtx(({ scope }) => [
            _createElementVNode("div", _hoisted_145, [
              (_unref(isJA)())
                ? (_openBlock(), _createBlock(EchartBtn, {
                    key: 0,
                    title: _unref(t)('THE CKB订单编号'),
                    list: echartRecordList.value,
                    metaData: _unref(metaData),
                    companyId: _unref(companyId),
                    orderNo: scope.row.platformOrderNo,
                    bizType: 1
                  }, null, 8, ["title", "list", "metaData", "companyId", "orderNo"]))
                : _createCommentVNode("", true),
              (!_unref(isD2C)())
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 1,
                    title: _unref(t)('复购'),
                    loading: scope.row.repurchaseCartLoading,
                    onClick: _withModifiers(($event: any) => (openRepurchaseCartVisible(scope.row)), ["stop"])
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true),
              (_unref(isArray)(scope.row.stageInfos) && scope.row.stageInfos.some((v) => [1, 4].includes(v.freezeStatus) && v.purchaseApplyFlag) && scope.row.platformOrderSettleStatus !== 3)
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 2,
                    title: _unref(t)('分期付款'),
                    onClick: _withModifiers(($event: any) => (openConfirmPartPayInfo(scope.row)), ["stop"])
                  }, null, 8, ["title", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_table_button, {
                title: _unref(t)('详情'),
                onClick: _withModifiers(($event: any) => (jump(_unref(useRtfix)('OrderInfo', { params: { id: scope.row.platformOrderId }, query: { type: scope.row.orderSource !== 1 ? 1 : '' } }))), ["stop"])
              }, null, 8, ["title", "onClick"]),
              (scope.row.preferDeliverFlag == 1 && scope.row.deliveryReviewFlag === 1)
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 3,
                    title: _unref(t)('优先发货'),
                    loading: scope.row.deliveryPriorityLoading,
                    onClick: _withModifiers(($event: any) => (deliveryPriority(scope.row)), ["stop"])
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true),
              (scope.row.orderCompositeStatus.split(',').some((v) => v < 32))
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 4,
                    title: _unref(t)('申请取消'),
                    loading: scope.row.applyCancelLoading,
                    onClick: _withModifiers(($event: any) => (applyCancel(scope.row)), ["stop"])
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("span", null, [
                _createVNode(_component_el_popconfirm, {
                  "popper-class": "pay-pop",
                  title: getPayTitle(scope.row),
                  onConfirm: ($event: any) => (toPay(scope.row))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_table_button, {
                      title: _unref(t)('去支付'),
                      loading: scope.row.payLoading,
                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, ["title", "loading"])
                  ]),
                  _: 2
                }, 1032, ["title", "onConfirm"]),
                false
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      visible: false,
                      effect: "light",
                      placement: "bottom-end",
                      "hide-after": 0,
                      "show-after": 200,
                      ref: `memberPopver${scope.row.platformOrderId}`
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_146, [
                          _createElementVNode("div", _hoisted_147, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_icon, {
                                color: "#E6A23C",
                                class: "icon-style",
                                size: "14px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Warning))
                                ]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_148, _toDisplayString(_unref(t)('说明')), 1)
                            ]),
                            _createVNode(_component_el_icon, {
                              onClick: closePopver,
                              color: "#F56C6C",
                              size: "14px",
                              style: {"cursor":"pointer"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CircleClose))
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_149, [
                            (_unref(isSub))
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  innerHTML: _unref(t)('尊敬的用户，您需办理会员后，方可下单，请联系主账号办理').replace('请联系主账号办理', `<span style='font-weight:bold'>请联系主账号办理</span>`)
                                }, null, 8, _hoisted_150))
                              : (_openBlock(), _createElementBlock("p", _hoisted_151, _toDisplayString(_unref(t)('尊敬的用户，您需办理会员后，方可下单')), 1))
                          ]),
                          _createVNode(_component_router_link, {
                            to: _unref(useRtfix)('VipLevel')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, { class: "btn mt_5" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('办理会员')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_table_button, {
                          title: _unref(t)('去支付'),
                          onClick: _withModifiers(($event: any) => (toPay2(scope.row)), ["stop"])
                        }, null, 8, ["title", "onClick"]), [
                          [_vShow, !templateLevel.value]
                        ])
                      ]),
                      _: 2
                    }, 1536))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, scope.row.platformOrderStatus == 2]
              ]),
              (scope.row.afterSalesFlag === 1)
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 5,
                    title: _unref(t)('售后'),
                    loading: scope.row.afterSaleLoading,
                    onClick: _withModifiers(($event: any) => (afterSale(scope.row)), ["stop"])
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true),
              (scope.row.supportSwapWareFlag && _unref(isReplaceWhiteUser))
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 6,
                    title: _unref(t)('仓库变更'),
                    onClick: _withModifiers(($event: any) => (replaceWareRef.value.show(scope.row)), ["stop"])
                  }, null, 8, ["title", "onClick"]))
                : _createCommentVNode("", true),
              (_unref(emailSetting)?.whitelistEnabled&&_unref(emailSetting).authStatus==2&&((scope.row.platformOrderType==1&&scope.row.orderSource== 1&&scope.row.emailAllSkuSentFlag==0)||scope.row.orderSource== 3&&Array.isArray(scope.row.emailHistoryList)&&scope.row.emailHistoryList?.find(i=>i.status=='FAILED')||scope.row?.needOpenSend))
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 7,
                    title: _unref(t)('メール送信'),
                    loading: scope.row.sendEmailLoading,
                    onClick: _withModifiers(($event: any) => (openSendEmailDrawer(scope.row)), ["stop"])
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          platformOrderSettleStatus: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(settlementStatus)[row.platformOrderSettleStatus]), 1)
          ]),
          abnormalSlot: _withCtx(({ row }) => [
            _createElementVNode("div", null, [
              (row?.untreatedNum > 0 || row?.processedNum > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                    (row?.untreatedNum > 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "abnormal-jump",
                          onClick: _withModifiers(($event: any) => (jumpAbnormalOrder(row, 'order', 1)), ["stop"])
                        }, _toDisplayString(_unref(t)('未处理')) + "（" + _toDisplayString(row.untreatedNum) + "）>", 9, _hoisted_153))
                      : _createCommentVNode("", true),
                    _hoisted_154,
                    (row?.processedNum > 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "abnormal-jump",
                          onClick: _withModifiers(($event: any) => (jumpAbnormalOrder(row, 'order', 0)), ["stop"])
                        }, _toDisplayString(_unref(t)('已处理')) + "（" + _toDisplayString(row.processedNum) + "）>", 9, _hoisted_155))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_156, "-"))
            ])
          ]),
          deliveryCountry: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(countryCodeNameMap).get(row.deliveryCountry) ?? '-'), 1)
          ]),
          _: 1
        }, 8, ["page-data", "api", "filterData", "columns", "onSelectionChange", "onExpandRow", "onExpandAll"])
      ]),
      _createVNode(ApplyCancelDialog, {
        visible: applyCancelVisible.value,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((applyCancelVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: refreshInfo
      }, null, 8, ["visible", "rowItem", "dataList"]),
      _createVNode(DeliveryPriorityDialog, {
        visible: deliveryPriorityVisible.value,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((deliveryPriorityVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: _unref(refreshTable)
      }, null, 8, ["visible", "rowItem", "dataList", "onRefresh"]),
      _createVNode(AfterSalesDialog, {
        visible: afterSaleVisible.value,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((afterSaleVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: _unref(refreshTable)
      }, null, 8, ["visible", "rowItem", "dataList", "onRefresh"]),
      _createVNode(RepurchaseDialog, {
        visible: repurchaseCartVisible.value,
        "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((repurchaseCartVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: _unref(refreshTable)
      }, null, 8, ["visible", "rowItem", "dataList", "onRefresh"]),
      _createVNode(BDialog, {
        title: _unref(t)('国际物流单号信息'),
        visible: inVisible.value,
        "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((inVisible).value = $event)),
        rowItem: rowItem.value
      }, null, 8, ["title", "visible", "rowItem"]),
      _createVNode(FinalPriceDialog, {
        visible: finalStatus.value,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((finalStatus).value = $event)),
        finalData: finalData.value,
        currentUnit: currentUnit.value
      }, null, 8, ["visible", "finalData", "currentUnit"]),
      _createVNode(CombinationDialog, {
        visible: combinationVisible.value,
        "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((combinationVisible).value = $event)),
        rowItem: rowItem.value
      }, null, 8, ["visible", "rowItem"]),
      (!_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 1,
            name: "b2b-order-list"
          }))
        : _createCommentVNode("", true),
      (!_unref(isD2C)() && _unref(tableData).length > 0)
        ? (_openBlock(), _createBlock(Guide, {
            key: 2,
            name: "b2b-order"
          }))
        : _createCommentVNode("", true),
      (_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 3,
            name: "d2c-order-list"
          }))
        : _createCommentVNode("", true),
      (_unref(isD2C)() && _unref(tableData).length > 0)
        ? (_openBlock(), _createBlock(Guide, {
            key: 4,
            name: "d2c-order"
          }))
        : _createCommentVNode("", true),
      _createVNode(BatchSearch),
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          (showAdt.value)
            ? (_openBlock(), _createBlock(AdditionDrawer, {
                key: 0,
                cfg: deliveryAdditionalList.value,
                "onUpdate:cfg": _cache[18] || (_cache[18] = ($event: any) => ((deliveryAdditionalList).value = $event)),
                onClose: _cache[19] || (_cache[19] = ($event: any) => (showAdt.value = false)),
                reback: "",
                onSave: editSendAddition,
                type: "DeliAdt"
              }, null, 8, ["cfg"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })),
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          (goodsAdditionList.value)
            ? (_openBlock(), _createBlock(AdditionDrawer, {
                key: 0,
                list: goodsAdditionList.value,
                "onUpdate:list": _cache[20] || (_cache[20] = ($event: any) => ((goodsAdditionList).value = $event)),
                onCommit: handleAdt,
                type: "AdtOrder",
                proxy: goodsRowItem.value,
                countryCode: additionCountryCode.value,
                noSpot: goodsRowItem.value.orderQuantity === 1 || choiceCost.value,
                choiceCost: choiceCost.value,
                hiddenRMB: hiddenRMB.value
              }, null, 8, ["list", "proxy", "countryCode", "noSpot", "choiceCost", "hiddenRMB"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })),
      _createVNode(QuickResponseAdditionTemplateConfirm, {
        ref: (_value, _refs) => {
          _refs['quickResponseAdditionTemplateConfirmRef'] = _value
          quickResponseAdditionTemplateConfirmRef.value = _value
        }
      }, null, 512),
      _createVNode(UploadFail, {
        visible: uploadFailVisible.value,
        "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((uploadFailVisible).value = $event)),
        failInfo: failInfo.value
      }, null, 8, ["visible", "failInfo"]),
      _createVNode(PartPayDialog, {
        visible: partPayVisible.value,
        "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((partPayVisible).value = $event)),
        title: _unref(t)('分期付款'),
        rowItem: rowItem.value,
        onHandlePartPay: handlePartPay,
        partPayLoading: partPayLoading.value
      }, null, 8, ["visible", "title", "rowItem", "partPayLoading"]),
      _createVNode(BalanceDialog, {
        visible: balanceVisible.value,
        "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((balanceVisible).value = $event)),
        title: _unref(t)('余额不足')
      }, null, 8, ["visible", "title"])
    ], 2),
    _createVNode(DrawerDocumentaryRecord, {
      ref: (_value, _refs) => {
        _refs['drawerDocumentaryRecordRef'] = _value
        drawerDocumentaryRecordRef.value = _value
      }
    }, null, 512),
    _createVNode(NoStockModal, {
      visible: visible.value,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((visible).value = $event)),
      goods: goods.value
    }, null, 8, ["visible", "goods"]),
    _createVNode(BatchDeliveryDialog, {
      ref: (_value, _refs) => {
        _refs['batchDeliveryModal'] = _value
        batchDeliveryModal.value = _value
      },
      onSuccess: confirmBatchPriorityDelivery,
      orderNum: _unref(selectedOrderList).length
    }, null, 8, ["orderNum"]),
    _createVNode(Recharge, {
      ref: (_value, _refs) => {
        _refs['rechargeRef'] = _value
        rechargeRef.value = _value
      },
      choiceTotalAmount: _unref(choiceTotalAmount),
      shopWallet: shopWallet.value,
      onSuccess: paySuccess
    }, null, 8, ["choiceTotalAmount", "shopWallet"]),
    _createVNode(CreateOrderSuccess, {
      ref: (_value, _refs) => {
        _refs['createOrderSuccessRef'] = _value
      }
    }, null, 512),
    _createVNode(UnRechargeModal),
    _createVNode(UnBalanceConfirm, {
      ref: (_value, _refs) => {
        _refs['unBalanceConfirmRef'] = _value
        unBalanceConfirmRef.value = _value
      }
    }, null, 512),
    _createVNode(ReplaceGoods, {
      ref: (_value, _refs) => {
        _refs['replaceGoodsRef'] = _value
        replaceGoodsRef.value = _value
      },
      onSuccess: handleReplaceGoods,
      onError: handleReplaceGoodsError
    }, null, 512),
    _createVNode(ReplaceWare, {
      ref: (_value, _refs) => {
        _refs['replaceWareRef'] = _value
        replaceWareRef.value = _value
      },
      onSuccess: handleReplaceWare
    }, null, 512),
    _createVNode(SendEmailDrawer, {
      ref: (_value, _refs) => {
        _refs['sendEmailDrawerRef'] = _value
        sendEmailDrawerRef.value = _value
      },
      onSuccess: _unref(refreshTable)
    }, null, 8, ["onSuccess"])
  ], 64))
}
}

})